import { pdf } from '@react-pdf/renderer'
import { toFixed } from 'accounting'
import axios from 'axios'
import Decimal from 'decimal.js'
import { saveAs } from 'file-saver'
import IMask from 'imask'
import { DateTime } from 'luxon'
import { toDataURL } from 'qrcode'
import React, {
  lazy,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { IconType } from 'react-icons'
import { AiOutlineWallet } from 'react-icons/ai'
import { BiMinus, BiTransfer } from 'react-icons/bi'
import { BsCreditCard } from 'react-icons/bs'
import { FaArrowLeft, FaCreditCard } from 'react-icons/fa'
import { FiAlertTriangle, FiTrash2 } from 'react-icons/fi'
import { GiReceiveMoney } from 'react-icons/gi'
import { HiCheck, HiOutlinePencil } from 'react-icons/hi'
import { IoMdAdd } from 'react-icons/io'
import { MdOutlineFileCopy } from 'react-icons/md'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import {
  ColumnsTable,
  HeaderActions,
  IClient,
  IExistenceInSale,
  IItem,
  IMoneyAccount,
  IWarehouse,
} from 'safe'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { TabContext } from '../../context/TabContext'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { fectchAccounts } from '../../redux/actions/accounts'
import { createClient } from '../../redux/actions/clients'
import { fetchRates } from '../../redux/actions/rates'
import { RootState } from '../../redux/store'
import { tax } from '../../userConfig'
import {
  dateToDB,
  formatPipe,
  getDenomination,
  getIvaNumber,
} from '../../utils/utils'
import AuditPDF from './AuditPDF'

const Modal = lazy(() => import('../../components/Display/Modal'))
const Table = lazy(() => import('../../components/Display/Table'))
const Button = lazy(() => import('../../components/General/Button'))
const ClientForm = lazy(() => import('../Clients/ClientsForm'))
const TransferForm = lazy(() => import('./TransferForm'))
const CardForm = lazy(() => import('./CardForm'))
const CashForm = lazy(() => import('./CashForm'))
const WalletForm = lazy(() => import('./WalletForm'))
const PdfView = lazy(() => import('../../components/Display/PdfView'))
const ControlNumberForm = lazy(() => import('./ControlNumberForm'))
const AdvancedSearch = lazy(
  () => import('../../components/Inputs/AdvancedSearch')
)
const IgtfForm = lazy(() => import('./IgtfForm'))
const CreditSaleForm = lazy(() => import('./CreditSaleForm'))
const Switch = lazy(() => import('../../components/Inputs/Switch'))
const PdfSale = lazy(() => import('./PdfSale'))
const Datepicker = lazy(() => import('../../components/Inputs/Datepicker'))
const Select = lazy(() => import('../../components/Inputs/Select'))
// const AuditPDF = lazy(() => import('./AuditPDF'))
const C2pForm = lazy(() => import('./C2pForm'))
const Tooltip = lazy(() => import('../../components/Display/Tooltip'))
const ZelleForm = lazy(() => import('./ZelleForm'))
const PagoMovilForm = lazy(() => import('./PagoMovilForm'))
const RetentionForm = lazy(() => import('./RetentionForm'))

enum accountTypeEnum {
  CASH = 'CASH',
  BANKACCOUNT = 'BANK ACCOUNT',
  WALLET = 'WALLET',
  CARD = 'CARD',
  mobilePayment = 'mobilePayment',
  nationalTransfer = 'nationalTransfer',
  CREDIT = 'CREDIT',
  IGTF = 'IGTF',
  C2P = 'C2P',
  ZELLE = 'ZELLE',
  PAGO_MOVIL = 'PAGO_MOVIL',
  RETENTION = 'RETENTION',
}

enum TypeStatus {
  DONE = 'DONE',
  UNDONE = 'UNDONE',
}

const server = process.env.REACT_APP_SERVER_URL

const Sells: React.FC<SellProps> = ({
  setHeaderActions,
  clientProp = null,
  itemsProp = [],
  statusProp = 'REFUND',
  selldId,
  payment_methods = [],
  onGoBack,
  type = '',
  alreadySelledProp = false,
  paidOut = false,
  dispatchStatusProps = 'UNDISPATCHED',
  onContinue = () => {},
  discountProp = null,
}) => {
  const history = useHistory()
  const today = DateTime.local().setLocale('es')

  const { value, onClick } = useContext(TabContext)

  const [tenantConfig, setTenantConfig] = useState<any>(null)

  const [isDisableForDay, setIsDisableForDay] = useState<boolean>(false)

  const refDocument = useRef<HTMLInputElement | null>(null)

  const refCode = useRef<HTMLInputElement | null>(null)

  const refQuantity = useRef<HTMLInputElement | null>(null)

  const refInputAdvanced = useRef<HTMLInputElement | null>(null)

  const [selectedClient, setSelectedClient] =
    useState<any | null | undefined>(clientProp)

  const [selectedItems, setSelectedItems] = useState<
    | (IItem & {
        amount: string
        enableEdit: boolean
        id_item_sale: string
        updated?: boolean
        ivaType: 'GENERAL' | 'REDUCED' | 'EXEMPT' | 'SUMPTUARY'
        currency: { id: string }
      })[]
    | undefined
  >([])

  useEffect(() => {
    if (itemsProp.length) {
      setSelectedItems(itemsProp)
    }
  }, [itemsProp])

  const [searchClient, setSearchClient] = useState<IClient[]>([])

  const [searchItems, setSearchItems] = useState<IExistenceInSale[]>([])

  const [error, setError] = useState<string | null>(null)

  const [showModalItems, setShowModalItems] = useState<boolean>(false)

  const [showIgtfModal, setShowIgtfModal] = useState<boolean>(false)

  const [itemToSearch, setItemToSearch] = useState<string>('')

  const [itemsSearched, setItemsSearched] = useState<IExistencesResponse[]>([])

  const [showAddClient, setShowAddClient] = useState<boolean>(false)

  const [isPaymentMethod, setIsPaymentMethod] = useState<boolean>(false)

  const [showMethod, setShowMethod] = useState<boolean>(false)

  const [selectedMethod, setSelectedMethod] = useState<IMethods | null>(null)

  const [isFreeForm, setIsFreeForm] = useState<boolean>(true)

  const [showPdf, setShowPdf] = useState<boolean>(false)
  const [digitalInvoicePdfUrl, setDigitalInvoicePdfUrl] =
    useState<string | null>(null)

  const [showPdfDeliveryNote, setShowPdfDeliveryNote] = useState<boolean>(false)

  const [selectedMethods, setSelectedMethods] = useState<any>(payment_methods)

  const [selectedRetentions, setSelectedRetentions] = useState<any[]>([])

  // const [accountsFilter, setAccounts] = useState(
  //   useSelector((state: RootState) => state.acct.accounts)
  // )

  const [saleData, setSaleData] = useState<any>(null)

  const [correlativeNumber, setCorrelativeNumber] = useState<string>('')

  const [alreadySelled, setAlreadySelled] = useState<boolean>(alreadySelledProp)

  const [isPayed, setIsPayed] = useState<boolean>(false)

  const [dispatchStatus, setDispatchStatus] =
    useState<string>(dispatchStatusProps)

  const dispatch = useDispatch()

  const clients = useSelector((state: RootState) => state.clie.clients)

  const userName = useSelector((state: RootState) => state?.auth?.user?.name)

  const userRole = useSelector(
    (state: RootState) => state?.auth?.user['custom:user_role']
  )

  const userPlan = useSelector(
    (state: RootState) => state?.auth?.user['custom:user_plan']
  )

  const globalRateRedux = useSelector((state: RootState) => state?.rates.rates)

  let alreadyInitialized = useRef<boolean>(false)

  const { addAlert } = useSnackBars()

  const [finishedDeliveryToSale, setFinishedDeliveryToSale] =
    useState<boolean>(false)

  const [stateBills, setStateBills] = useState<Bill[]>([])

  const [status, setStatus] = useState<any>(statusProp)

  const [showModalControlNumber, setShowModalControlNumber] =
    useState<boolean>(false)

  const accounts = useSelector((state: RootState) => state.acct.accounts)

  const warehouses = useSelector((state: RootState) => state.warh.warehouses)

  const [globalRate, setGlobalRate] = useState<IGlobalRate[]>([])

  const [igtfAmount, setIgtfAmount] = useState<number>(0)

  const [isCashOut, setIsCashOut] = useState<boolean>(true)

  const [credit, setCredit] = useState<ICredit | null>(null)

  const [disableDiscount, setDisableDiscount] = useState<boolean>(false)

  const [discountValue, setDiscountValue] = useState<number>(discountProp || 0)

  const [showAdvancedPayable, setShowAdvancedPayable] = useState<boolean>(false)

  const [invoiceNumber, setInvoiceNumber] = useState<string>('')

  const discountRef = useRef<any>(null)

  const amountRef = useRef<any>(null)

  const [saleDate, setSaleDate] = useState<string>(
    DateTime.local().setLocale('es').toFormat('d/M/yyyy')
  )

  const [modalRate, setModalRate] = useState<string | null>(null)

  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)

  const [isHigherState, setIsHigherState] = useState<boolean>(false)

  const [showCloseBoxModal, setShowCloseBoxModal] = useState<boolean>(false)

  const [accountsSelect, setAccountsSelect] = useState<any[]>([])

  const [selectedAccount, setSelectedAccount] = useState<any>(null)

  const [auditBody, setAuditBody] = useState<any>(null)

  const [c2pMode, setC2pMode] = useState<boolean>(false)

  const [paymentId, setPaymentId] = useState<string | null>(null)

  const [qrCode, setQrcode] = useState<string>('')

  const [seconds, setSeconds] = useState(5 * 60)

  const [amountC2p, setAmountC2p] = useState<string>('0')

  const [tokenClient, setTokenClient] = useState<null | any>(null)

  const [isIGTFActive, setIsIGTFActive] = useState<boolean>(false)

  const [invoiceMethod, setInvoiceMethod] = useState<any>(null)

  const [showInvoiceMethodModal, setShowInvoiceMethodModal] =
    useState<boolean>(false)

  // const refDisable = useRef<HTMLInputElement|null>(null)

  // const styles = StyleSheet.create({
  //   general: {
  //     padding: 40,
  //   },
  //   page: {
  //     flexDirection: 'row',
  //     justifyContent: 'space-between',
  //     width: '40%',
  //     marginBottom: '2%',
  //   },
  //   section: {
  //     flexGrow: 1,
  //   },
  //   items: {
  //     display: 'flex',
  //     flexDirection: 'row',
  //     justifyContent: 'space-between',
  //     borderBottom: '1px dashed black',
  //   },
  //   priceTotal: {
  //     display: 'flex',
  //     alignItems: 'flex-end',
  //     marginTop: '2%',
  //   },
  //   priceUnit: {
  //     display: 'flex',
  //     justifyContent: 'flex-end',
  //   },
  //   amounts: {
  //     flexDirection: 'row',
  //     justifyContent: 'space-between',
  //     width: '35%',
  //     marginBottom: '2%',
  //   },
  // })

  const onGetInvoiceMethod = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    setInvoiceMethod(response.data.tenant.invoiceMethod)
  }

  useEffect(() => {
    onGetInvoiceMethod()
  }, [])

  // Activar descuento automáticamente cuando viene de prorrateo
  useEffect(() => {
    if (
      discountProp !== null &&
      discountProp > 0 &&
      selectedItems &&
      selectedItems.length > 0
    ) {
      console.log('========== CALCULANDO DESCUENTO DESDE PORCENTAJE ==========')
      console.log('Porcentaje de descuento recibido:', discountProp, '%')

      // Calcular el subtotal usando la misma función que usa Sells
      const subtotal = sumOfValues('sub_total')
      console.log('Subtotal calculado por Sells:', subtotal, 'Bs')
      console.log('Fórmula:', `${subtotal} × (${discountProp} / 100)`)

      // Calcular el valor absoluto del descuento en Bs usando Decimal.js
      const discountAmount = new Decimal(subtotal)
        .mul(discountProp)
        .div(100)
        .toDecimalPlaces(2)
        .toNumber()
      console.log('Descuento calculado en Bs:', discountAmount)
      console.log('========== FIN CÁLCULO ==========')

      setDisableDiscount(true)
      setDiscountValue(discountAmount)

      // Prellenar el input del descuento usando IMask después de un pequeño delay
      // para asegurarse de que el ref esté disponible
      setTimeout(() => {
        if (discountRef.current) {
          discountRef.current.value = discountAmount.toString()
        }
      }, 100)
    }
  }, [discountProp, selectedItems])

  useEffect(() => {
    // console.log('Selected methods', toFixed(0.615, 2))
    // console.log('Selected methods', (0.615).toFixed(2))
  }, [selectedMethods])

  useEffect(() => {
    // history.push('/dashboard/modulo_ventas/ventas')
    console.log('clickeando desde ventas...')
    if (showPdf) {
      console.log('llega..')
      setShowPdf(false)
      setSelectedClient(null)
      setSelectedItems([])
      setIgtfAmount(0)
      setSearchClient([])
      setSearchItems([])
      // setSelectedMethod([])
      setSelectedMethods([])
      setSelectedRetentions([])
      setIsCashOut(true)
      setIsPaymentMethod(false)

      // Limpiar PDF digital si existe
      if (digitalInvoicePdfUrl) {
        console.log(
          '🧹 [Digital Invoice] Liberando Blob URL:',
          digitalInvoicePdfUrl
        )
        URL.revokeObjectURL(digitalInvoicePdfUrl)
        setDigitalInvoicePdfUrl(null)
      }
    }
  }, [value])

  // useEffect(() => {

  // }, [invoiceNumber])

  useEffect(() => {
    let numberMask = IMask(discountRef.current, {
      mask: Number,
      thousandsSeparator: '.',
      radix: ',',
      scale: 2,
      normalizeZeros: true,
      padFractionalZeros: true,
      signed: false,
      max: 10000000000000,
    })

    numberMask.on('accept', () => {
      setDiscountValue(+numberMask.unmaskedValue)
    })
  }, [])

  // useEffect(() => {
  //   if (amountRef && amountRef.current) {
  //     let amountMask = IMask(amountRef.current, {
  //     mask: Number,
  //     thousandsSeparator: '.',
  //     radix: ',',
  //     scale: 2,
  //     normalizeZeros: true,
  //     padFractionalZeros: true,
  //     signed: false,
  //     max: 10000000000000,
  //   })
  //   }
  // }, [amountRef, selectedItems])

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const getRate = async (
    date = today.toISODate(),
    fromRedux = true
  ): Promise<void> => {
    if (fromRedux) {
      const today = DateTime.local().setLocale('es')
      // let date = today.toISODate()
      dispatch(fetchRates([`date=${date}`, `currency=${'all'}`]))
      // let response = await axios.get<{ rates: IGlobalRate[] }>(
      //   `${server}/finances/rate?date=${date}&currency=all`
      // )
      // console.log('response...', response)
      // setGlobalRate(response.data.rates)
    } else {
      let response = await axios.get(
        `${server}/finances/rate?date=${date}&currency=${'all'}`
      )
      setGlobalRate(response.data.rates)
      if (!isFirstRender) {
        setModalRate(
          response?.data?.rates?.find((rate) => rate?.id === '1')?.rate
        )
      }
      setIsFirstRender(false)
    }
  }

  useEffect(() => {
    getRate()
  }, [])

  useEffect(() => {
    if (globalRateRedux.length) {
      setGlobalRate(globalRateRedux)
    }
  }, [globalRateRedux])

  const onSearchClient = async (
    value = refInputAdvanced?.current?.value,
    isFromNewClient = false
  ): Promise<void> => {
    // if (
    //   /^[^vjepgc].+$/gi.test(
    //     (refDocument.current && refDocument.current.value) || ''
    //   )
    // ) {
    //   setError('Cédula inválida')
    //   return
    // }
    // const documentInfo = refDocument?.current?.value.split('-')
    // let response = await axios.get<{ clients: IClient[] }>(
    //   `${server}/thirdparty/client?document=${
    //     documentInfo && documentInfo[1]
    //   }&documentType=${documentInfo && documentInfo[0]}&pageNumber=1&pageSize=5`
    // )
    // setError('')

    let response = await axios.get(
      `${server}/thirdparty/client?${[
        ...[`fastSearch=${value}`],
        ...[`pageNumber=${1}&pageSize=${10}`],
      ].join('&')}`
    )
    setSearchClient(response.data.clients)

    // setSelectedClient(
    //   response.data.clients.find(
    //     (client) =>
    //       client.document.document === (documentInfo && documentInfo[1]) &&
    //       client.document.documentType === (documentInfo && documentInfo[0])
    //   )
    // )
    // refDocument.current && (refDocument.current.value = '')
    // refCode.current && (refCode.current.value = '')

    if (response.data.clients.length === 0) {
      addAlert({
        message: 'No se encontraron clientes',
        status: 'error',
      })
      return
    }

    if (isFromNewClient) {
      setSelectedClient(response.data.clients[0])
    }
  }

  const onSearchItem = async (
    value = refCode?.current?.value
  ): Promise<void> => {
    if (value === '') {
      addAlert({
        message: 'Debe de al menos escribir un caracter',
        status: 'error',
      })
      return
    }

    setSearchItems([])
    // let response =  await axios.get<{existencesOfWarehouse: IExistence[]}>(`${server}/inventory/existence?evaluate=code&idWarehouse=1&pageNumber=1&pageSize=100&code=${refCode.current?.value}`)
    // console.log("respinse", response.data.existencesOfWarehouse.find(v => v.))
    // let response = await axios.get<{ items: IItem[] }>(
    //   `${server}/inventory/item/search/custom?searchCustom=${refCode.current?.value}`
    // )
    // console.log("response1", response1)
    // console.log(response.data.existencesOfWarehouse.find(existence => existence.item.barcode === (refCode?.current && refCode.current?.value) || existence.item.sku === (refCode?.current && refCode.current?.value)) )
    //@ts-ignore
    // setSelectedItems((prevState) => [...prevState,{amount: refQuantity.current.value,
    //     ...response.data.items.find(
    //       (item) =>
    //         item.barcode === (refCode?.current && refCode.current?.value) ||
    //         item.sku === (refCode?.current && refCode.current?.value)
    //     ),
    //   },
    // ])

    // let warehouseId = warehouses[0]?.id

    let warehouseId = warehouses.find(
      (warehouse) => warehouse.warehouseType === 'SALE FLOOR'
    )?.id

    if (!warehouseId) {
      addAlert({
        message: 'No se encontró un almacén de piso de ventas',
        status: 'error',
      })
      return
    }

    let [items, services] = await Promise.all([
      await axios.get(
        `${server}/inventory/existence?id=${warehouseId}&${[
          `fastSearch=${value}`,
          `sale=true`,
          `pageNumber=${1}&pageSize=${10}`,
        ].join('&')}`
      ),
      await axios.get(
        `${server}/service?name=${value}&${['pageNumber=1', 'pageSize=10'].join(
          '&'
        )}`
      ),
    ])

    console.log('items...', items)
    console.log('services...', services)

    // let response = await axios.get(
    //   `${server}/inventory/existence?id=${warehouseId}&${[
    //     `fastSearch=${value}`,
    //     `sale=true`,
    //     `pageNumber=${1}&pageSize=${10}`,
    //   ].join('&')}`
    // )

    if (items?.data?.items?.length > 0) {
      setSearchItems((prevState) => [...prevState, ...items?.data?.items])
    }

    if (services?.data?.services?.length > 0) {
      setSearchItems((prevState) => [...prevState, ...services?.data?.services])
    }

    // setSearchItems([...items?.data?.items, ...services?.data?.services])
    refCode?.current && (refCode.current.value = '')
    refQuantity?.current && (refQuantity.current.value = '')

    // if (items?.data?.items?.length  === 1) {
    //   onPressRow(items.data.items[0])
    // }

    if (
      items?.data?.existence?.length === 0 &&
      services?.data?.services?.length === 0
    ) {
      addAlert({
        message: 'No se encontraron artículos ni servicios',
        status: 'error',
      })
    }
  }

  const returnBody = (surplusAction: 'PAYABLE' | 'ADVANCE') => {
    let warehouse = warehouses.find(
      (warehouse) => warehouse.warehouseType === 'SALE FLOOR'
    )?.id

    const today = DateTime.local().setLocale('es')

    return {
      saleClient: {
        id: selectedClient?.id,
      },
      warehouse: {
        id: warehouse,
      },
      paidOut: false,
      description: 'Una venta',
      total: toFixed(getTotalAmount(), 2),
      // total: getTotalAmount().toFixed(2),
      discount: discountValue + '',
      iva: toFixed(sumOfValues('iva'), 2),
      // iva: sumOfValues('iva').toFixed(2),
      igtf: toFixed(igtfAmount, 2),
      // igtf: igtfAmount.toFixed(2),
      date: dateToDB(saleDate),
      currency: {
        id: '2',
      },
      exempt: toFixed(sumOfValues('exempt'), 2),
      payments: selectedMethods.map((v) => {
        const { type, ...rest } = v
        return rest
      }),
      items: selectedItems,
      surplusAction,
    }
  }

  const onGetRate = (idCurrency: string | undefined): string => {
    // console.log("globalRate...", globalRate)
    return globalRate.find((rate) => rate.id === idCurrency)?.rate || '1'
  }

  // Función específica para formatear precios de items en ventas
  // Esta función calcula: (precio × tasa) redondeado × cantidad
  // En lugar de: precio × tasa × cantidad redondeado
  const formatPipeSaleItems = (
    price: string,
    amount: string,
    currencyId: string | undefined
  ): string => {
    try {
      // Manejar valores vacíos o inválidos
      const priceValue = price || '0'
      const amountValue = amount || '0'

      const priceDecimal = new Decimal(priceValue)
      const amountDecimal = new Decimal(amountValue)
      const rateDecimal = new Decimal(onGetRate(currencyId))

      // Primero calcular el precio unitario en Bs y redondearlo
      const unitPriceInBs = priceDecimal.mul(rateDecimal).toDecimalPlaces(2)

      // Luego multiplicar por la cantidad y redondear nuevamente
      const totalPrice = unitPriceInBs.mul(amountDecimal).toDecimalPlaces(2)

      return formatPipe(totalPrice.toString().replace('.', ','))
    } catch (error) {
      console.warn('Error in formatPipeSaleItems:', {
        price,
        amount,
        currencyId,
        error,
      })
      return '0,00'
    }
  }

  // Función para calcular el IVA de items en ventas
  const formatPipeSaleItemsIva = (
    price: string,
    amount: string,
    currencyId: string | undefined,
    ivaType: 'GENERAL' | 'REDUCED' | 'EXEMPT' | 'SUMPTUARY'
  ): string => {
    try {
      // Manejar valores vacíos o inválidos
      const priceValue = price || '0'
      const amountValue = amount || '0'

      const priceDecimal = new Decimal(priceValue)
      const amountDecimal = new Decimal(amountValue)
      const rateDecimal = new Decimal(onGetRate(currencyId))

      // Calcular precio unitario en Bs y redondearlo
      const unitPriceInBs = priceDecimal.mul(rateDecimal).toDecimalPlaces(2)

      // Multiplicar por cantidad
      const totalPrice = unitPriceInBs.mul(amountDecimal)

      // Calcular el porcentaje de IVA
      const ivaPct = new Decimal(
        (getIvaNumber(ivaType) + '').replace(/\d\./, '')
      ).div(100)

      // Aplicar IVA
      const ivaAmount = totalPrice.mul(ivaPct).toDecimalPlaces(2)

      return formatPipe(ivaAmount.toString().replace('.', ','))
    } catch (error) {
      console.warn('Error in formatPipeSaleItemsIva:', {
        price,
        amount,
        currencyId,
        ivaType,
        error,
      })
      return '0,00'
    }
  }

  type SumKey = 'iva' | 'exempt' | 'total' | 'sub_total'

  // Esta función se hizo para evitar un crash
  // Valida que el valor sea un número válido antes de crear una instancia de Decimal
  const toDec = (v: Decimal.Value): Decimal => {
    try {
      return new Decimal(v ?? 0) // handles null | undefined
    } catch {
      return new Decimal(0) // handles '' or other junk
    }
  }

  const sumOfValues = (prop: SumKey): number => {
    // --- initialise the accumulator with Decimal instances ---------------
    const acc: Record<SumKey, Decimal> = {
      iva: new Decimal(0),
      exempt: new Decimal(0),
      total: new Decimal(0),
      sub_total: new Decimal(0),
    }

    selectedItems?.forEach((item) => {
      // --- common values --------------------------------------------------
      const price = toDec(item.price)
      const amount = toDec(item.amount)
      const rate = toDec(onGetRate(item.currency.id)) // Bs per unit

      // Calcular precio unitario en Bs primero, redondear, luego multiplicar por cantidad
      // Esto asegura consistencia con el display: (precio × tasa).round(2) × cantidad
      // IMPORTANTE: Redondear SIEMPRE el precio unitario, incluso si ya está en Bs
      const unitPriceInBs =
        item.currency.id === '2'
          ? price.toDecimalPlaces(2) // redondear precio en Bs también
          : price.mul(rate).toDecimalPlaces(2) // convertir y redondear primero

      // Redondear el subtotal de línea antes de sumarlo para evitar acumulación de decimales
      const lineBs = unitPriceInBs.mul(amount).toDecimalPlaces(2)

      // ---------------- IVA & EXENTO --------------------------------------
      if (item.ivaType === 'EXEMPT') {
        acc.exempt = acc.exempt.plus(lineBs)
      } else {
        // getIvaNumber("GENERAL") → e.g. 1.16  → "16" → 0.16
        const ivaPct = new Decimal(
          getIvaNumber(item.ivaType).toString().replace(/\d\./, '')
        ).div(100)

        // Redondear el IVA de cada línea antes de sumarlo para evitar acumulación de decimales
        acc.iva = acc.iva.plus(lineBs.mul(ivaPct).toDecimalPlaces(2))
      }

      // ---------------- subtotals / totals --------------------------------
      acc.sub_total = acc.sub_total.plus(lineBs) // always Bs
      acc.total = acc.total.plus(price.mul(amount)) // currency-agnostic
    })

    // return the requested field rounded to 2 decimals
    return acc[prop].toDecimalPlaces(2).toNumber()
  }

  // Version anterior de sumOfValues que usa accounting
  // const sumOfValues = (prop: string): number => {
  //   return selectedItems?.reduce(
  //     (a, b) => {
  //       // a['iva'] += b.exempt
  //       //   ? 0
  //       //   : +((+b?.price / getIvaNumber(b?.ivaType) ) * (tax / 100)) *
  //       //     +b?.amount
  //       // a['iva'] += b.ivaType === 'EXEMPT' ? +b.price : (+b.price * + ((getIvaNumber(b?.ivaType) + "").replace(/\d\./, ""))/100)
  //       a['iva'] =
  //         b.ivaType === 'EXEMPT'
  //           ? a['iva']
  //           : // :  (+b.price *
  //             //     +b.amount *
  //             //     +onGetRate(b.currency.id) *
  //             //     +(getIvaNumber(b?.ivaType) + '').replace(/\d\./, '') ) /
  //             //   100
  //             +a['iva'] +
  //             +toFixed(+b.price * +b.amount * +onGetRate(b?.currency?.id), 2) *
  //               +toFixed(
  //                 +(getIvaNumber(b?.ivaType) + '').replace(/\d\./, '') / 100,
  //                 2
  //               )
  //       a['exempt'] +=
  //         b.ivaType === 'EXEMPT'
  //           ? +toFixed(+b.price * +b.amount * +onGetRate(b?.currency?.id), 2)
  //           : 0
  //       // a['sub_total'] += !b.exempt
  //       //   ? +(
  //       //       (+b?.price / getIvaNumber(b?.ivaType)) *
  //       //       +b.amount
  //       //     ).toFixed(2)
  //       //   : 0
  //       a['sub_total'] =
  //         b.currency.id === '2'
  //           ? +toFixed(a['sub_total'] + +b?.price * +b?.amount, 2)
  //           : +toFixed(
  //               a['sub_total'] +
  //                 +b.price * +b.amount * +onGetRate(b.currency.id),
  //               2
  //             )
  //       a['total'] = +toFixed(+a['total'] + +b.price * +b.amount, 2)
  //       return a
  //     },
  //     { iva: 0, exempt: 0, total: 0, sub_total: 0 }
  //   )[prop]
  // }

  // Este version esta deprecada
  // const getTotalAmount = () =>
  //   +sumOfValues('sub_total').toFixed(2) +
  //   +sumOfValues('iva').toFixed(2) +
  //   +sumOfValues('exempt').toFixed(2) +
  //   +igtfAmount.toFixed(2)

  //Version anterior de getTotalAmount que usa accounting
  // const getTotalAmount = (withDiscount: boolean = true) =>
  //   +toFixed(
  //     +toFixed(sumOfValues('sub_total'), 2) +
  //       +toFixed(sumOfValues('iva'), 2) +
  //       // +toFixed(sumOfValues('exempt'), 2) +
  //       +toFixed(igtfAmount, 2) -
  //       (withDiscount ? discountValue : 0),
  //     2
  //   )

  /**
   * Calcula el total final (sub-total + IVA + IGTF – descuento opcional),
   * retornando siempre un número redondeado a 2 decimales.
   */
  const getTotalAmount = (withDiscount: boolean = true): number => {
    const subTotal = new Decimal(sumOfValues('sub_total')) // Bs
    // console.log('subTotal', subTotal.toDecimalPlaces(2).toNumber())
    const iva = new Decimal(sumOfValues('iva')) // Bs
    const igtf = new Decimal(igtfAmount) // Bs
    const discount = withDiscount ? new Decimal(discountValue) : new Decimal(0)

    const total = subTotal.plus(iva).plus(igtf).minus(discount)

    return total.toDecimalPlaces(2).toNumber()
  }

  /**
   * Calcular el total de retenciones
   */
  const getTotalRetentions = (): number => {
    return selectedRetentions.reduce(
      (acc, retention) => acc.plus(new Decimal(retention.amount || 0)),
      new Decimal(0)
    ).toDecimalPlaces(2).toNumber()
  }

  /**
   * Calcular el total con retenciones (Total - Retenciones = Total a Pagar)
   */
  const getTotalWithRetentions = (): number => {
    const total = new Decimal(getTotalAmount())
    const retentions = new Decimal(getTotalRetentions())
    return total.minus(retentions).toDecimalPlaces(2).toNumber()
  }

  /**
   * Formatear número decimal para API de retenciones (punto a coma con exactamente 2 decimales)
   */
  const formatDecimalForRetentionAPI = (value: number | string): string => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value
    const fixedValue = numValue.toFixed(2)
    return fixedValue.replace('.', ',')
  }

  /**
   * Agregar padding de ceros a la izquierda para que el documento tenga 9 dígitos
   */
  const padDocumentNumber = (documentNumber: string): string => {
    const cleanNumber = documentNumber.replace(/\D/g, '')
    return cleanNumber.padStart(9, '0')
  }

  /**
   * Validar y formatear teléfono para que tenga exactamente 11 dígitos
   */
  const formatPhoneFor11Digits = (phone: string | null | undefined): string => {
    if (!phone) return '04120000000'
    const cleanPhone = phone.replace(/\D/g, '')
    return cleanPhone.length === 11 ? cleanPhone : '04120000000'
  }

  /**
   * Construir body para retención IVA
   */
  const buildIvaRetentionBody = (
    retention: any,
    client: any,
    userName: string,
    userPassword: string,
    invoiceCode: string,
    numeroControl: string,
    saleDate: string
  ) => {
    return {
      payload: {
        data: [
          {
            cliente: [
              {
                documentoIdentidadCliente: `${client?.documentType || 'V'}${padDocumentNumber(client?.document || '0')}`,
                nombreRazonSocialCliente: client?.name || 'Cliente Genérico',
                correoCliente: client?.email || 'sin-correo@example.com',
                direccionCliente: client?.address || 'Dirección no especificada',
                telefonoCliente: formatPhoneFor11Digits(client?.phone1),
              },
            ],
            RetencionIva: [
              {
                fechaDeFactura: DateTime.fromFormat(saleDate, 'd/M/yyyy').toISODate(),
                numeroFactura: invoiceCode || 'N/A',
                numeroControl: numeroControl || 'N/A',
                numeroNotaDeCredito: 'N/A',
                numeroNotaDeDebito: 'N/A',
                numeroFacturaAfectada: 'N/A',
                totalDeCompraIncluyendoIva: formatDecimalForRetentionAPI(retention.totalDeCompraIncluyendoIva || 0),
                compraSinDerechoACreditoFiscal: formatDecimalForRetentionAPI(retention.compraSinDerechoACreditoFiscal || 0),
                baseImponible: formatDecimalForRetentionAPI(retention.baseImponible || 0),
                porcentaje: `${retention.porcentaje || 0}%`,
              },
            ],
          },
        ],
      },
      auth: {
        userName,
        userPassword,
      },
    }
  }

  /**
   * Construir body para retención ISLR
   */
  const buildIslrRetentionBody = (
    retention: any,
    client: any,
    userName: string,
    userPassword: string,
    numeroControl: string,
    saleDate: string,
    invoiceCode: string
  ) => {
    return {
      payload: {
        data: [
          {
            cliente: [
              {
                documentoIdentidadCliente: `${client?.documentType || 'V'}${padDocumentNumber(client?.document || '0')}`,
                nombreRazonSocialCliente: client?.name || 'Cliente Genérico',
                correoCliente: client?.email || 'sin-correo@example.com',
                direccionCliente: client?.address || 'Dirección no especificada',
                telefonoCliente: formatPhoneFor11Digits(client?.phone1),
              },
            ],
            retencionIslr: [
              {
                numeroDocumento: invoiceCode || 'N/A',
                numeroControl: numeroControl || 'N/A',
                fecha: DateTime.fromFormat(saleDate, 'd/M/yyyy').toISODate(),
                // codigo: usar valor del input o default "034"
                codigo: retention.codigo || '034',
                // conceptoPago: usar valor del input o default "REGALIAS ART 27 # 16 LISLR"
                conceptoPago: retention.conceptoPago || 'REGALIAS ART 27 # 16 LISLR',
                montoDocumento: formatDecimalForRetentionAPI(retention.montoDocumento || 0),
                baseRetencion: formatDecimalForRetentionAPI(retention.baseRetencion || 0),
                porcentaje: `${retention.porcentaje || 0}%`,
                montoRetenido: formatDecimalForRetentionAPI(retention.amount || 0),
                codigoRetencionIslr: '001',
              },
            ],
          },
        ],
      },
      auth: {
        userName,
        userPassword,
      },
    }
  }

  const onGetDebt = (): string => {
    const totalAmount = new Decimal(getTotalAmount())
    const paidAmount = selectedMethods.reduce(
      (acc, method) =>
        acc.plus(new Decimal(method.amount).mul(method?.rate || 1)),
      new Decimal(0)
    )
    // Restar las retenciones del total (las retenciones reducen el monto a pagar)
    const retentionsAmount = new Decimal(getTotalRetentions())
    return toFixed(
      totalAmount.minus(paidAmount).minus(retentionsAmount).toDecimalPlaces(2).toNumber(),
      2
    )
  }

  const debt = useMemo(
    () => onGetDebt(),
    [
      selectedMethods,
      selectedItems,
      igtfAmount,
      saleDate,
      discountValue,
      itemsProp,
      selectedRetentions,
    ]
  )

  useEffect(() => {
    let isHigher = checkDebt()

    setIsHigherState(isHigher)
  }, [debt])

  const onGetChange = (): any => {
    const cashTotal = selectedMethods.reduce((acc, method) => {
      if (method.type === 'Efectivo') {
        return acc.plus(new Decimal(method.amount).mul(method?.rate || 1))
      }
      return acc
    }, new Decimal(0))
    const totalAmount = new Decimal(getTotalAmount())

    if (cashTotal.greaterThan(totalAmount)) {
      return toFixed(
        cashTotal.minus(totalAmount).toDecimalPlaces(2).toNumber(),
        2
      )
    }
    return 0
  }

  const formatValueToSave = (method: IMoneyAccount) => {
    console.log('method', method)

    if (method?.type === 'Crédito') {
      console.log('in...')
      return {
        ...method,
        accountType: accountTypeEnum.CREDIT,
      }
    }

    if (method.cardSwiperNumber !== '') {
      return {
        ...method,
        accountType: 'CARD',
      }
    }

    if (method.type === 'Cuenta Bancaria') {
      return {
        ...method,
        accountType: 'WIRE TRANSFER',
      }
    }

    if (method.mobilePaymentPhone !== '') {
      return {
        ...method,
        accountType: 'MOBILE PAYMENT',
      }
    }

    // if (method.bankAccountNumber !== '') {
    //   return {
    //     ...method,
    //     accountType: 'WIRE TRANSFER',
    //   }
    // }

    return method
  }

  const checkDebt = () => {
    let amount = selectedMethods.reduce((a, b) => {
      // console.log("amount", b)
      if (b?.currency?.id === '1') {
        return a + +b?.amount
      }
      return a
    }, 0)

    return (
      amount === +toFixed(getTotalAmount() / +onGetRate('1'), 2) &&
      +debt <= 0.15
    )
  }

  const onCreateSell = async (): Promise<void> => {
    if (invoiceMethod !== 'free_form' && invoiceMethod !== 'digital') {
      setShowInvoiceMethodModal(true)
      // addAlert({
      //   message:
      //     'No puede generar una venta si su tipo de facturación no es "Forma libre" o "Digital"',
      //   status: 'error',
      // })
      return
    }

    let isHigher = checkDebt()
    // setIsHigherState(isHigher)
    // console.log("HIGHER", isHigher)

    if (+debt > 0 && isCashOut && !isHigher) {
      addAlert({
        message: 'El monto de pago debe de ser mayor o igual al monto de venta',
        status: 'error',
      })
      return
    }

    let services = selectedItems
      ?.filter((service) => !service?.category?.id)
      .map((service) => {
        // Limpiar servicios: solo incluir los campos necesarios, sin type ni category
        const { type, category, ...rest } = service
        return {
          amount: rest.amount,
          id: rest.id,
          name: rest.name,
          price: rest.price,
          ivaType: rest.ivaType,
          currency: rest.currency,
        }
      })

    let items = selectedItems?.filter((item) => item?.category?.id)

    let paymentMethodType = {
      'Billetera Virtual': 'WALLET',
      'Cuenta Bancaria': 'TRANSFERENCE',
      Efectivo: 'CASH',
      'Punto de venta': 'CARD',
      'Pago Móvil': 'MOBILE PAYMENT',
      Crédito: 'CREDIT',
    }

    const today = DateTime.local().setLocale('es')

    let warehouse = warehouses.find(
      (warehouse) => warehouse.warehouseType === 'SALE FLOOR'
    )?.id

    let objBody = {}

    if (
      credit?.finalDate &&
      credit.installmentQuantity &&
      credit.installmentRange &&
      credit.startDate
    ) {
      if (services?.length && items?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: false,
          description: 'Una venta',
          total: toFixed(getTotalAmount(), 2),
          // total: getTotalAmount().toFixed(2),
          discount: discountValue + '',
          iva: toFixed(sumOfValues('iva'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // igtf: igtfAmount.toFixed(2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          // date: today.toISODate(),
          currency: {
            id: '2',
          },
          items,
          services,
          exempt: toFixed(sumOfValues('exempt'), 2),
          credit: {
            ...credit,
            startDate: dateToDB(credit.startDate),
            finalDate: dateToDB(credit.finalDate),
          },
        }
      }

      if (services?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: false,
          description: 'Una venta',
          total: toFixed(getTotalAmount(), 2),
          // total: getTotalAmount().toFixed(2),
          discount: discountValue + '',
          iva: toFixed(sumOfValues('iva'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // igtf: igtfAmount.toFixed(2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          currency: {
            id: '2',
          },
          exempt: toFixed(sumOfValues('exempt'), 2),
          services,
          credit: {
            ...credit,
            startDate: dateToDB(credit.startDate),
            finalDate: dateToDB(credit.finalDate),
          },
        }
      }

      if (items?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: false,
          description: 'Una venta',
          total: toFixed(getTotalAmount(), 2),
          // total: getTotalAmount().toFixed(2),
          discount: discountValue + '',
          iva: toFixed(sumOfValues('iva'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // igtf: igtfAmount.toFixed(2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          currency: {
            id: '2',
          },
          exempt: toFixed(sumOfValues('exempt'), 2),
          items,
          credit: {
            ...credit,
            startDate: dateToDB(credit.startDate),
            finalDate: dateToDB(credit.finalDate),
          },
        }
      }
    } else if (+debt <= 0 || isHigher) {
      if (items?.length && services?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          exempt: toFixed(sumOfValues('exempt'), 2),
          items,
          services,
        }
      }

      if (items?.length && !services?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          exempt: toFixed(sumOfValues('exempt'), 2),
          items,
        }
      }

      if (services?.length && !items?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          exempt: toFixed(sumOfValues('exempt'), 2),
          services,
        }
      }
    }

    // if (+debt < 0) {
    //   // addAlert({
    //   //   message: 'El total ingresado debe de ser mayor o igual a la deuda',
    //   //   status: 'error',
    //   // })
    //   // return
    //   setShowAdvancedPayable(true)
    //   return
    // }

    try {
      addAlert({ message: 'Creando venta...', status: 'loading' })
      let userResponse = await axios.get(`${server}/user/tenant`)
      let configResponse = await axios.get(`${server}/config/tenant`)

      // Variable para almacenar la URL del PDF de factura digital
      let digitalInvoicePdfUrlForSale: string | null = null
      // Variable para almacenar el número de control de la factura digital
      let digitalInvoiceControlNumber: string | null = null

      if (invoiceMethod === 'digital') {
        // Generar venta con facturación digital
        try {
          // Obtener credenciales de configuración del tenant
          const digitalInvoiceUsername =
            configResponse?.data?.userConf?.digitalInvoiceUsername
          const digitalInvoicePassword =
            configResponse?.data?.userConf?.digitalInvoicePassword
          const digitalInvoiceSerie =
            configResponse?.data?.userConf?.digitalInvoiceSerie

          // Validar que las credenciales estén configuradas
          if (
            !digitalInvoiceUsername ||
            !digitalInvoicePassword ||
            !digitalInvoiceSerie
          ) {
            addAlert({
              message:
                'Las credenciales de facturación digital no están configuradas. Por favor, configúralas en la sección de Configuración.',
              status: 'error',
            })
            return
          }

          // Helper: Convertir número de punto a coma para la API con exactamente 2 decimales
          const toCommaDecimal = (value: number | string): string => {
            // Asegurar que siempre tenga exactamente 2 decimales
            const numValue =
              typeof value === 'string' ? parseFloat(value) : value
            const fixedValue = numValue.toFixed(2)
            return fixedValue.replace('.', ',')
          }

          // Helper: Agregar padding de ceros a la izquierda para que el documento tenga 9 dígitos
          const padDocumentNumber = (documentNumber: string): string => {
            // Remover cualquier carácter no numérico
            const cleanNumber = documentNumber.replace(/\D/g, '')
            // Hacer padding a 9 dígitos
            return cleanNumber.padStart(9, '0')
          }

          // Helper: Mapear ivaType a código de impuesto de la API
          const mapIvaType = (ivaType: string): string => {
            const mapping: Record<string, string> = {
              GENERAL: 'G',
              REDUCED: 'R',
              EXEMPT: 'E',
            }
            return mapping[ivaType] || 'G' // Default a General si no se encuentra
          }

          // Helper: Mapear tipo de pago de selectedMethods a OrderPaymentMethodType
          const mapPaymentMethodType = (
            type: string
          ): 'divisa' | 'transferencia' | 'pago_movil' | 'efectivo' => {
            // Console log para debugging
            console.log('🔍 [Digital Invoice] Payment method type:', type)

            const mapping: Record<
              string,
              'divisa' | 'transferencia' | 'pago_movil' | 'efectivo'
            > = {
              Efectivo: 'efectivo',
              'Cuenta Bancaria': 'transferencia',
              'Billetera Virtual': 'transferencia',
              'Punto de venta': 'transferencia',
              'Pago Móvil': 'pago_movil',
              C2P: 'transferencia',
              Zelle: 'divisa',
              // Agrega más mapeos según sea necesario
            }

            return mapping[type] || 'efectivo' // Default a efectivo
          }

          // Console log para debugging de selectedMethods
          console.log('🔍 [Digital Invoice] selectedMethods:', selectedMethods)

          // Obtener tasa del día como número para hacer conversiones (USD y EUR)
          const tasaDelDiaNumero = parseFloat(onGetRate('1'))
          const tasaDelDiaEuroNumero = parseFloat(onGetRate('3'))
          console.log('🔍 [Digital Invoice] Tasa del día USD:', tasaDelDiaNumero)
          console.log('🔍 [Digital Invoice] Tasa del día EUR:', tasaDelDiaEuroNumero)

          // Mapear selectedItems a InvoiceProduct[]
          const productos =
            selectedItems?.map((item) => {
              // Obtener el precio base del item
              const precioBase = parseFloat(item.price) || 0

              // Convertir a bolívares según la moneda del item:
              // currency.id = '1' -> USD: multiplicar por tasa USD
              // currency.id = '3' -> EUR: multiplicar por tasa EUR
              // currency.id = '2' -> Bs: usar el precio directamente
              let precioEnBolivares: number
              if (item.currency?.id === '1') {
                // USD: multiplicar por la tasa del dólar
                precioEnBolivares = new Decimal(precioBase)
                  .mul(tasaDelDiaNumero)
                  .toDecimalPlaces(2)
                  .toNumber()
              } else if (item.currency?.id === '3') {
                // EUR: multiplicar por la tasa del euro
                precioEnBolivares = new Decimal(precioBase)
                  .mul(tasaDelDiaEuroNumero)
                  .toDecimalPlaces(2)
                  .toNumber()
              } else {
                // Bs u otra moneda: usar precio directamente
                precioEnBolivares = precioBase
              }

              console.log(
                `🔍 [Digital Invoice] Item: ${item.name}, Currency ID: ${item.currency?.id}, Precio base: ${precioBase}, Precio en Bs: ${precioEnBolivares}`
              )

              return {
                codigoProducto: item.barcode || item.sku || item.id || 'N/A',
                nombreProducto: item.name || 'Producto sin nombre',
                descripcionProducto:
                  item.description || item.name || 'Sin descripción',
                tipoImpuesto: mapIvaType(item.ivaType),
                cantidadAdquirida: Number(item.amount) || 1,
                precioProducto: toCommaDecimal(precioEnBolivares),
              }
            }) || []

          // Mapear selectedMethods a OrderPaymentMethod[]
          const orderPaymentMethods = selectedMethods.map((method: any) => {
            const montoOriginal = parseFloat(method.amount) || 0
            const currencyId = method.currency?.id

            // Determinar tipo de pago según la moneda
            // currency.id = '1' -> USD -> "divisa"
            // currency.id = '2' -> Bs -> "efectivo"
            const paymentMethodType = currencyId === '1' ? 'divisa' : 'efectivo'

            // Calcular monto en bolívares
            let montoEnBolivares: number
            if (currencyId === '1') {
              // USD: multiplicar por la tasa
              montoEnBolivares = montoOriginal * tasaDelDiaNumero
            } else {
              // Bs: usar el monto tal cual
              montoEnBolivares = montoOriginal
            }

            console.log(
              `🔍 [Digital Invoice] Pago: ${method.type}, Currency ID: ${currencyId}, Monto original: ${montoOriginal}, Monto en Bs: ${montoEnBolivares}`
            )

            const paymentMethod: any = {
              order_payment_method: paymentMethodType,
              monto: toCommaDecimal(montoEnBolivares),
            }

            // Si es divisa, agregar IGTF (3% del monto en Bs) usando Decimal.js
            if (paymentMethodType === 'divisa') {
              const igtfAmount = new Decimal(montoEnBolivares)
                .mul(0.03)
                .toDecimalPlaces(2)
                .toNumber()
              paymentMethod.igtf = toCommaDecimal(igtfAmount)
              console.log(
                `🔍 [Digital Invoice] IGTF calculado: ${igtfAmount} Bs`
              )
            }

            // Campos adicionales comentados (pueden necesitarse en el futuro)
            // if (paymentMethodType === 'transferencia') {
            //   paymentMethod.numero_de_referencia_de_operacion =
            //     method.reference?.slice(0, 4) || '0000'
            // }
            // if (paymentMethodType === 'pago_movil') {
            //   paymentMethod.telefono_pago_movil =
            //     selectedClient?.phone1 || '00000000000'
            // }

            return paymentMethod
          })

          // Convertir tasa del día a formato con coma para el payload
          const tasaDelDia = toCommaDecimal(tasaDelDiaNumero)

          // Construir el body completo para /digital-invoice
          const digitalInvoiceBody = {
            auth: {
              userName: digitalInvoiceUsername,
              userPassword: digitalInvoicePassword,
            },
            payload: {
              numeroSerie: digitalInvoiceSerie,
              cantidadFactura: 1,
              facturas: [
                {
                  numeroFactura: String(
                    tenantConfig?.invoiceCode || correlativeNumber || '00001'
                  ).padStart(5, '0'),
                  documentoIdentidadCliente: `${
                    selectedClient?.documentType || 'V'
                  }${padDocumentNumber(selectedClient?.document || '0')}`,
                  nombreRazonSocialCliente:
                    selectedClient?.name || 'Cliente Genérico',
                  correoCliente:
                    selectedClient?.email || 'sin-correo@example.com',
                  direccionCliente:
                    selectedClient?.address || 'Dirección no especificada',
                  telefonoCliente: selectedClient?.phone1 || '00000000000',
                  productos,
                  tasa_del_dia: tasaDelDia,
                  order_payment_methods: orderPaymentMethods,
                },
              ],
            },
          }

          console.log(
            '📄 [Digital Invoice] Body a enviar:',
            JSON.stringify(digitalInvoiceBody, null, 2)
          )

          // Hacer el POST a /digital-invoice
          addAlert({
            message: 'Generando factura digital...',
            status: 'loading',
            duration: 8000,
          })

          const digitalInvoiceResponse = await axios.post(
            `${server}/digital-invoice`,
            digitalInvoiceBody
          )

          // Validar la respuesta incluso si el status es 200
          const responseData = digitalInvoiceResponse.data

          // Verificar si es una respuesta exitosa (tiene control_number y pdf)
          const isSuccess = responseData.control_number && responseData.pdf

          // Si no es exitosa, verificar si hay errores
          if (!isSuccess) {
            const hasError =
              responseData.data?.success === false ||
              responseData.data?.message?.includes('Error') ||
              (responseData.data?.invoice_list_success?.length === 0 &&
                responseData.data?.invoice_errors?.length > 0)

            if (hasError) {
              console.error(
                '❌ [Digital Invoice] Error en respuesta del servidor:',
                responseData
              )
              throw new Error(
                responseData.data?.message || 'Error al generar factura digital'
              )
            }
          }

          console.log(
            '✅ [Digital Invoice] Factura digital generada exitosamente!'
          )
          console.log(
            '📋 [Digital Invoice] Control Number:',
            digitalInvoiceResponse.data.control_number
          )
          console.log(
            '📄 [Digital Invoice] PDF URL:',
            digitalInvoiceResponse.data.pdf
          )
          console.log(
            '💬 [Digital Invoice] Message:',
            digitalInvoiceResponse.data.message
          )

          addAlert({
            message: `Factura digital generada exitosamente. Por favor espere unos segundos mientras se genera el PDF.`,
            status: 'success',
            duration: 10000,
          })

          // Almacenar la URL del PDF para incluirla en el registro de venta
          digitalInvoicePdfUrlForSale = digitalInvoiceResponse.data.pdf
          // Almacenar el número de control para usarlo en las retenciones
          digitalInvoiceControlNumber = digitalInvoiceResponse.data.control_number

          // Descargar el PDF desde la URL proporcionada
          try {
            console.log(
              '📥 [Digital Invoice] Descargando PDF desde:',
              responseData.pdf
            )

            const pdfResponse = await fetch(responseData.pdf)
            if (!pdfResponse.ok) {
              throw new Error(
                `Error al descargar PDF: ${pdfResponse.statusText}`
              )
            }

            const pdfBlob = await pdfResponse.blob()
            const pdfBlobUrl = URL.createObjectURL(pdfBlob)

            console.log(
              '✅ [Digital Invoice] PDF descargado exitosamente, Blob URL creada:',
              pdfBlobUrl
            )

            setDigitalInvoicePdfUrl(pdfBlobUrl)
          } catch (pdfDownloadError: any) {
            console.error(
              '❌ [Digital Invoice] Error al descargar PDF:',
              pdfDownloadError
            )
            addAlert({
              message: 'Factura generada pero no se pudo descargar el PDF',
              status: 'warning',
            })
          }
        } catch (digitalInvoiceError: any) {
          console.error(
            '❌ [Digital Invoice] Error al generar factura digital:',
            digitalInvoiceError
          )
          console.error(
            '❌ [Digital Invoice] Error response:',
            digitalInvoiceError?.response?.data
          )

          // Determinar el mensaje de error apropiado
          let errorMessage =
            'Error al generar factura digital. No se puede crear la venta.'

          if (digitalInvoiceError.message) {
            // Error lanzado manualmente desde la validación
            errorMessage = digitalInvoiceError.message
          } else if (digitalInvoiceError?.response?.data?.data?.message) {
            // Error de la API
            errorMessage = digitalInvoiceError.response.data.data.message
          } else if (digitalInvoiceError?.response?.data?.message) {
            // Error alternativo de la API
            errorMessage = digitalInvoiceError.response.data.message
          }

          console.error('❌ [Digital Invoice] Mensaje de error:', errorMessage)

          // Detectar si es un error de factura duplicada
          const isDuplicateInvoice =
            errorMessage.toLowerCase().includes('facturas ya registradas') ||
            errorMessage.toLowerCase().includes('ya existe') ||
            (digitalInvoiceError?.response?.data?.data?.invoice_errors?.length >
              0 &&
              digitalInvoiceError?.response?.data?.data?.invoice_list_success
                ?.length === 0)

          // Mostrar mensaje específico según el tipo de error
          let userMessage = isDuplicateInvoice
            ? 'No se pudo generar la factura. Ya existe una factura registrada con ese número.'
            : 'No se pudo generar la factura digital. Por favor revisa que tus credenciales sean correctas e intenta de nuevo.'

          addAlert({
            message: userMessage,
            status: 'error',
            duration: 8000,
          })

          // Detener el flujo - NO continuar con la creación de la venta
          return
        }
      }

      // Agregar PDF URL al objBody si se generó factura digital
      if (invoiceMethod === 'digital' && digitalInvoicePdfUrlForSale) {
        objBody = {
          ...objBody,
          pdfUrl: digitalInvoicePdfUrlForSale,
        }
      }

      // Variable para almacenar datos de retención IVA
      let ivaRetentionPdfUrl: string | null = null
      let ivaRetentionNumber: string | null = null

      // Variable para almacenar datos de retención ISLR
      let islrRetentionPdfUrl: string | null = null
      let islrRetentionNumber: string | null = null

      // Procesar retención IVA ANTES de crear la venta (para obtener retention_number y retention_pdf)
      const ivaRetention = selectedRetentions.find(
        (r) => r.retentionType === 'IVA'
      )
      if (ivaRetention) {
        console.log('=== IVA Retention Debug ===')
        console.log('ivaRetention:', ivaRetention)

        // SOLO llamar a API externa si facturación es digital
        if (invoiceMethod === 'digital') {
          // Obtener credenciales
          const username = configResponse?.data?.userConf?.digitalInvoiceUsername
          const password = configResponse?.data?.userConf?.digitalInvoicePassword

          if (username && password) {
            try {
              console.log('📋 [Retención IVA] Procesando retención IVA antes de crear venta...')
              addAlert({ message: 'Procesando retención IVA...', status: 'loading' })

              const ivaRetentionBody = buildIvaRetentionBody(
                ivaRetention,
                selectedClient,
                username,
                password,
                tenantConfig?.invoiceCode || 'N/A',
                digitalInvoiceControlNumber || 'N/A',
                saleDate
              )

              console.log('📋 [Retención IVA] Body:', JSON.stringify(ivaRetentionBody, null, 2))

              const ivaRetentionResponse = await axios.post(
                `${server}/digital-invoice/iva-retention`,
                ivaRetentionBody
              )

              console.log('✅ [Retención IVA] Respuesta:', ivaRetentionResponse.data)

              // Guardar datos de la respuesta para usar en /sale
              ivaRetentionPdfUrl = ivaRetentionResponse.data.retention_pdf || null
              ivaRetentionNumber = ivaRetentionResponse.data.retention_number || null

              console.log('📋 [Retención IVA] PDF URL:', ivaRetentionPdfUrl)
              console.log('📋 [Retención IVA] Retention Number:', ivaRetentionNumber)

              addAlert({
                message: 'Retención IVA procesada exitosamente',
                status: 'success',
              })
            } catch (ivaRetentionError: any) {
              console.error('❌ [Retención IVA] Error:', ivaRetentionError)
              console.error('❌ [Retención IVA] Error response:', ivaRetentionError?.response?.data)
              addAlert({
                message: 'Error al procesar retención IVA: ' + (ivaRetentionError?.response?.data?.message || ivaRetentionError?.message || 'Error desconocido'),
                status: 'error',
              })
              // No detener el flujo, continuar con la venta
            }
          }
        }

        // Los valores vienen directamente de los props de RetentionForm (números)
        const taxBaseValue = ivaRetention.baseImponible || 0
        const taxRate = '16'
        // Usar el valor real del IVA (impuesto) en lugar de calcularlo
        const taxTotal = ivaRetention.impuesto || 0

        const ivaWithholding = {
          // Usar retention_number de la respuesta si está disponible
          voucherNumber: ivaRetentionNumber || (tenantConfig?.invoiceCode + '-1'),
          excempt: String(ivaRetention.compraSinDerechoACreditoFiscal || 0),
          taxBase: String(taxBaseValue),
          taxRate: taxRate,
          taxTotal: String(taxTotal),
          amountWithheld: ivaRetention.amount || '0',
          withholdingPercentage: ivaRetention.porcentaje || '0',
        }

        console.log('ivaWithholding:', ivaWithholding)

        objBody = {
          ...objBody,
          ivaWithholding,
          // Agregar ivaPdfUrl si se obtuvo de la retención
          ...(ivaRetentionPdfUrl && { ivaPdfUrl: ivaRetentionPdfUrl }),
        }
      }

      // Procesar retención ISLR ANTES de crear la venta
      const islrRetention = selectedRetentions.find(
        (r) => r.retentionType === 'ISLR'
      )
      if (islrRetention) {
        console.log('=== ISLR Retention Debug ===')
        console.log('islrRetention:', islrRetention)

        // SOLO llamar a API externa si facturación es digital
        if (invoiceMethod === 'digital') {
          const username = configResponse?.data?.userConf?.digitalInvoiceUsername
          const password = configResponse?.data?.userConf?.digitalInvoicePassword

          if (username && password) {
            try {
              console.log('📋 [Retención ISLR] Procesando retención ISLR antes de crear venta...')
              addAlert({ message: 'Procesando retención ISLR...', status: 'loading' })

              const islrRetentionBody = buildIslrRetentionBody(
                islrRetention,
                selectedClient,
                username,
                password,
                digitalInvoiceControlNumber || 'N/A',
                saleDate,
                tenantConfig?.invoiceCode || 'N/A'
              )

              console.log('📋 [Retención ISLR] Body:', JSON.stringify(islrRetentionBody, null, 2))

              const islrRetentionResponse = await axios.post(
                `${server}/digital-invoice/islr-retention`,
                islrRetentionBody
              )

              console.log('✅ [Retención ISLR] Respuesta:', islrRetentionResponse.data)

              // Guardar datos de la respuesta para usar en /sale
              islrRetentionPdfUrl = islrRetentionResponse.data.retention_pdf || null
              islrRetentionNumber = islrRetentionResponse.data.retention_number || null

              console.log('📋 [Retención ISLR] PDF URL:', islrRetentionPdfUrl)
              console.log('📋 [Retención ISLR] Retention Number:', islrRetentionNumber)

              addAlert({
                message: 'Retención ISLR procesada exitosamente',
                status: 'success',
              })
            } catch (islrRetentionError: any) {
              console.error('❌ [Retención ISLR] Error:', islrRetentionError)
              console.error('❌ [Retención ISLR] Error response:', islrRetentionError?.response?.data)
              addAlert({
                message: 'Error al procesar retención ISLR: ' + (islrRetentionError?.response?.data?.message || islrRetentionError?.message || 'Error desconocido'),
                status: 'error',
              })
              // No detener el flujo, continuar con la venta
            }
          }
        }

        // Construir islrWithholding para POST /sale (SIEMPRE, independiente del tipo de facturación)
        const islrWithholding = {
          voucherNumber: islrRetentionNumber || (tenantConfig?.invoiceCode + '-ISLR'),
          subtrahend: String(islrRetention.sustraendo || 0),
          taxBase: String(islrRetention.baseRetencion || 0),
          // taxRate: alícuota ISLR (1%, 2%, 3%, 5%)
          taxRate: String(islrRetention.alicuota || 0),
          // Para ISLR, taxTotal = amountWithheld (monto retenido)
          taxTotal: String(islrRetention.amount || 0),
          amountWithheld: islrRetention.amount || '0',
          // withholdingPercentage: porcentaje de retención (100% o 75%)
          withholdingPercentage: islrRetention.porcentaje || '0',
        }

        console.log('islrWithholding:', islrWithholding)

        objBody = {
          ...objBody,
          islrWithholding,
          // Agregar islrPdfUrl si se obtuvo de la retención
          ...(islrRetentionPdfUrl && { islrPdfUrl: islrRetentionPdfUrl }),
        }
      }

      let response = await axios.post(`${server}/sale`, objBody)

      // Si hubo retención IVA, crear el registro de withholding
      if (ivaRetention && response?.data?.sale?.id) {
        try {
          console.log('📋 [Withholding] Creando registro de retención...')

          // Los valores vienen directamente de los props de RetentionForm (números)
          const taxBaseValue = ivaRetention.baseImponible || 0
          const taxRate = '16'
          const taxTotal = ivaRetention.impuesto || 0

          const withholdingBody = {
            id: response.data.sale.id,
            voucherNumber: ivaRetentionNumber || (tenantConfig?.invoiceCode + '-1'),
            excempt: String(ivaRetention.compraSinDerechoACreditoFiscal || 0),
            taxBase: String(taxBaseValue),
            taxRate: taxRate,
            taxTotal: String(taxTotal),
            amountWithheld: ivaRetention.amount || '0',
            withholdingPercentage: ivaRetention.porcentaje || '0',
          }

          console.log('📋 [Withholding] Body:', withholdingBody)

          await axios.post(`${server}/sale/withholding`, withholdingBody)

          console.log('✅ [Withholding] Registro de retención creado exitosamente')
        } catch (withholdingError: any) {
          console.error('❌ [Withholding] Error al crear registro de retención:', withholdingError)
          console.error('❌ [Withholding] Error response:', withholdingError?.response?.data)
          // No detener el flujo si falla
        }
      }

      // Si hubo retención ISLR, crear el registro de withholding
      if (islrRetention && response?.data?.sale?.id) {
        try {
          console.log('📋 [ISLR Withholding] Creando registro de retención ISLR...')

          const islrWithholdingBody = {
            id: response.data.sale.id,
            voucherNumber: islrRetentionNumber || (tenantConfig?.invoiceCode + '-ISLR'),
            subtrahend: String(islrRetention.sustraendo || 0),
            taxBase: String(islrRetention.baseRetencion || 0),
            // taxRate: alícuota ISLR (1%, 2%, 3%, 5%)
            taxRate: String(islrRetention.alicuota || 0),
            // Para ISLR, taxTotal = amountWithheld (monto retenido)
            taxTotal: String(islrRetention.amount || 0),
            amountWithheld: islrRetention.amount || '0',
            // withholdingPercentage: porcentaje de retención (1%, 2%, 3%, 5%)
            withholdingPercentage: islrRetention.porcentaje || '0',
            concept: islrRetention.conceptoPago || 'REGALIAS ART 27 # 16 LISLR',
            code: islrRetention.codigo || '034',
          }

          console.log('📋 [ISLR Withholding] Body:', islrWithholdingBody)

          await axios.post(`${server}/sale/islr-withholding`, islrWithholdingBody)

          console.log('✅ [ISLR Withholding] Registro de retención ISLR creado exitosamente')
        } catch (islrWithholdingError: any) {
          console.error('❌ [ISLR Withholding] Error al crear registro de retención ISLR:', islrWithholdingError)
          console.error('❌ [ISLR Withholding] Error response:', islrWithholdingError?.response?.data)
          // No detener el flujo si falla
        }
      }

      // Variable para trackear si se actualizó la suscripción
      let subscriptionUpdated = false

      // Verificar si la venta proviene de facturación de suscripción
      const urlParams = new URLSearchParams(window.location.search)
      const subscriptionId = urlParams.get('subscriptionId')
      const clientId = urlParams.get('clientId')

      // Solo actualizar suscripción si viene del módulo de suscripciones
      if (subscriptionId && clientId) {
        try {
          // El subscriptionId del query param ES el subscriptionClientId
          const subscriptionSaleBody = {
            clientId: parseInt(clientId),
            subscriptionClientId: parseInt(subscriptionId),
            idSale: parseInt(response?.data?.sale?.id),
            date: dateToDB(saleDate),
            amount: parseFloat(toFixed(getTotalAmount(), 2)),
            usdAmount: parseFloat(
              toFixed(getTotalAmount() / +onGetRate('1'), 2)
            ),
          }

          console.log(
            '🔵 [Sells] Enviando POST a /subscription/sale con body:',
            subscriptionSaleBody
          )

          // Registrar la venta en el historial de suscripción
          await axios.post(`${server}/subscription/sale`, subscriptionSaleBody)
          console.log(
            '✅ [Sells] Venta registrada en historial de suscripción exitosamente'
          )

          subscriptionUpdated = true
        } catch (subscriptionError: any) {
          // Log del error pero continuar con la venta (no fallar toda la venta por esto)
          console.error(
            '🔴 [Sells] Error al registrar venta en historial de suscripción:',
            subscriptionError
          )
          console.error(
            '🔴 [Sells] Error status:',
            subscriptionError?.response?.status
          )
          console.error(
            '🔴 [Sells] Error data:',
            subscriptionError?.response?.data
          )

          addAlert({
            message:
              'La venta se creó correctamente, pero no se pudo registrar en el historial de suscripción',
            status: 'warning',
          })
        }
      }

      if (statusProp === 'FOOD_ORDER') {
        const id = new URLSearchParams(window.location.search).get('id')

        const body = {
          id,
          id_sale: response?.data?.sale?.id,
          active: 'false',
        }

        await axios.patch(`${server}/food-order?id=${id}`, body)
      }

      let saleInfo = await axios.get(
        `${server}/sale?id=${response?.data?.sale?.id}`
      )

      setSaleData(saleInfo?.data?.sale)

      console.log('response', response?.data?.sale?.id)

      let date = dateToDB(saleDate)

      const [year, month, day] = date.split('-')

      if (selectedClient?.email && selectedClient?.emailConfirmed) {
        let emailBody = {
          invoiceCode: response?.data?.invoice?.code,
          nevulaUser: {
            businessName: userResponse?.data?.tenant?.businessSocial,
          },
          client: {
            name: selectedClient?.name,
            document: `${selectedClient?.documentType}-${selectedClient?.document}`,
            email: selectedClient?.email,
          },
          // subTotal: sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(sumOfValues('sub_total'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          discount: discountValue + '',
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          date: `${day}/${month}/${year}`,
          userMessage: configResponse?.data?.userConf?.saleEmailMessage,
          logoURL: userResponse.data.tenant.image,
          // 'https://i.pinimg.com/736x/ec/7c/af/ec7cafae1224c318796d41e728eacb6d.jpg',
          items: selectedItems?.map((item) => ({
            quantity: item.amount,
            description: item.name,
            unitPrice: item.price,
            totalPrice: +item?.amount * +item?.price,
          })),
        }
        let responseEmail = await axios.post(`${server}/sale/email`, emailBody)
      }

      setInvoiceNumber(response?.data?.invoice?.code)
      setShowPdf(true)

      // Actualizar configuración del tenant para reflejar el nuevo número de documento
      await onGetTenantConfig()

      // Mostrar mensaje de éxito apropiado según si se actualizó la suscripción
      if (subscriptionId && clientId) {
        if (subscriptionUpdated) {
          addAlert({
            message: 'Venta exitosa y registrada en historial de suscripción',
            status: 'success',
          })
        } else {
          // La venta fue exitosa pero no se pudo registrar en el historial
          addAlert({
            message: 'Venta creada satisfactoriamente',
            status: 'success',
          })
        }
      } else {
        // Venta normal (no es de suscripción)
        addAlert({
          message: 'Venta creada satisfactoriamente',
          status: 'success',
        })
      }
    } catch (err: any) {
      // Mostrar mensaje específico si el error viene del historial de suscripción
      const errorMessage = err?.message || 'Error al crear la venta'
      addAlert({ message: errorMessage, status: 'error' })
    }
  }

  useEffect(() => {
    if (
      (status === 'PENDING' ||
        status === 'REFUND' ||
        status === 'DELIVERY_NOTE_TO_SALE' ||
        status === 'PENDING_DELIVERY') &&
      payment_methods.length !== 0
    ) {
      setIsPaymentMethod(true)
    }
  }, [])

  async function initializeGapiClient() {
    //@ts-ignore
    await gapi?.client?.init({
      apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
      discoveryDocs: [
        'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
      ],
    })
  }

  function gisLoaded() {
    //@ts-ignore
    let tokenClient = google?.accounts?.oauth2?.initTokenClient({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      scope: 'https://www.googleapis.com/auth/gmail.readonly',
      callback: '', // defined later
    })
    console.log('token', tokenClient)
    setTokenClient(tokenClient)
  }

  useEffect(() => {
    //@ts-ignore
    gapi.load('client', initializeGapiClient)
    gisLoaded()
  }, [])

  const columnsSearchItems: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'item.name',
      key: 'item.name',
    },
    {
      title: 'SKU',
      dataIndex: 'item.sku',
      key: 'item.sku',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.item.sku ? '' : 'text-gray-600'}`}
        >
          {record?.item.sku || 'N/A'}
        </ColumnItemWrapper>
      ),
      width: 50,
    },
    {
      title: 'Código',
      dataIndex: 'item.barcode',
      key: 'item.barcode',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.item.barcode ? '' : 'text-gray-600'}`}
        >
          {record?.item.barcode || 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Precio',
      dataIndex: 'item.price',
      key: 'item.price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p
            className={`${
              !(record?.item.price.length > 0) ? 'text-warning' : 'text-success'
            }`}
          >
            {record?.item.price.length > 0 ? (
              'Bs ' + record?.item.price[0]?.amount
            ) : (
              <span>
                Sin Precio <FiAlertTriangle className="text-warning inline" />
              </span>
            )}
          </p>
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Categoría',
      dataIndex: 'item.category.name',
      key: 'item.category.name',
    },
    {
      title: 'Disponibilidad',
      dataIndex: 'quantity',
      key: 'quantity',
    },
  ]

  const columnsSearchClients: ColumnsTable[] = [
    {
      title: 'NOMBRE',
      dataIndex: 'name',
      key: 'name',
      render: (x: any, client: any) => (
        <ColumnItemWrapper>{client?.name?.toUpperCase()}</ColumnItemWrapper>
      ),
    },
    // {
    //   title: 'Teléfono',
    //   dataIndex: 'phone',
    //   key: 'phone',
    //   width: 140,
    //   render: (x: any, client: any) => (
    //     <ColumnItemWrapper>
    //       {/* <div> */}
    //       <p
    //         style={{
    //           whiteSpace: 'pre',
    //           overflow: 'hidden',
    //           textOverflow: 'ellipsis',
    //         }}
    //       >
    //         {client?.phones
    //           .map(
    //             (phone, i) =>
    //               `${phone.country.dialCode || phone.country.dial_code} ${
    //                 phone.number
    //               }`
    //           )
    //           .join('\n')}
    //       </p>
    //       {/* </div> */}
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: 'DOCUMENTO',
      dataIndex: 'document',
      key: 'document',
      render: (x: any, client: any) => (
        <ColumnItemWrapper>
          {client?.documentType}-{client.document}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'CORREO',
      dataIndex: 'email',
      key: 'email',
      render: (x: any, client: any) => (
        <ColumnItemWrapper>{client?.email?.toUpperCase()}</ColumnItemWrapper>
      ),
    },
  ]

  const columnsSearchInSell: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      tootltipValue: true,
    },
    {
      title: 'Código',
      dataIndex: 'sku',
      key: 'sku',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.sku ? '' : 'text-gray-600'}`}
        >
          {record?.sku || 'N/A'}
        </ColumnItemWrapper>
      ),
      width: 50,
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p>
            {`${getDenomination(record?.currency?.id)} ${formatPipe(
              record?.price
            )}`}
          </p>
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Categoría',
      dataIndex: 'category.name',
      key: 'category.name',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p>{record?.category?.name || 'N/A'}</p>
        </ColumnItemWrapper>
      ),
    },
  ]

  // const getItems = async () => {
  //   let response = await axios.get<{ items: IItem[] }>(
  //     `${server}/inventory/item/search/custom?searchCustom=${refCode.current?.value}`
  //   )
  //   setSearchItems(response.data.items)
  // }

  // useEffect(() => {
  //   if (selectedClient) {
  //     // let response = await axios.get<{ items: IItem[] }>(
  //     //   `${server}/inventory/item/search/custom?searchCustom=${refCode.current?.value}`
  //     // )
  //     getItems()
  //   }
  // }, [selectedClient])

  const onFilterActions = (headerActions) => {
    if (status === 'DELIVERY_NOTE_TO_SALE') {
      const { searchItems, onPending, ...rest } = headerActions
      return rest
    }
    if (status === 'PENDING') {
      const { onFreeForm, ...rest } = headerActions
      return rest
    }
    if (status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY') {
      const { searchItems, onFreeForm, ...rest } = headerActions
      return {
        ...rest,
        onPayed: (checked, setCheckedPayed) => {
          if (selectedMethods.length > 0) {
            // {status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
            //           ? (sumOfValues('sub_total') - +selectedMethods
            //           .reduce((a, b) => a + +b.amount, 0)).toFixed(2)
            //           : (getTotalAmount() - +selectedMethods
            //               .reduce((a, b) => a + +b.amount, 0)).toFixed(2)}
            console.log(
              'sub_total',
              sumOfValues('sub_total') + sumOfValues('exempt')
            )
            let value = +toFixed(
              +toFixed(sumOfValues('sub_total'), 2) +
                +toFixed(sumOfValues('exempt'), 2) -
                +toFixed(
                  +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                  2
                ),
              2
            )
            if (value === 0) {
              setCheckedPayed(true)
              setIsPayed(true)
            } else {
              setCheckedPayed(false)
              setIsPayed(false)
            }
          } else {
            setIsPayed(checked)
          }
        },
        onChangeDeliveryStatus: (value) => {
          setDispatchStatus(value)
        },
      }
    }
    return headerActions
  }

  useEffect(() => {
    setHeaderActions(
      {
        onShowRate: () => {},
        onCloseBox: async () => {
          let response = await axios.get(`${server}/finances/account`)
          setAccountsSelect(
            response.data.accounts.map((v) => ({
              text: v.description,
              value: v.id,
            }))
          )
          setShowCloseBoxModal(true)
        },
      }
      // onFilterActions({
      // searchItems: (value: string) => {
      //   setItemToSearch(value)
      // },
      // onPending: () => {
      //   onCreatePendingSell()
      // },
      // onChangeSaleType: (value) => {
      //   // console.log("value...", value)
      //   setStatus(value)
      // },
      // onFreeForm: (v, setCheckedSale) => {
      //   setIsFreeForm(v)
      //   if (status === 'PENDING' && type === 'FREE FORM') {
      //     setCheckedSale(true)
      //     setIsFreeForm(true)
      //   } else {
      //     if (!alreadyInitialized.current) {
      //       alreadyInitialized.current = true
      //       setCheckedSale(false)
      //     }
      //   }
      // },
      // onChangeToDelivery: (v) => {
      //   // if (v) {
      //   //   history.push('/dashboard/notadeentrega/notaventa')
      //   // } else {
      //   //   history.push('/dashboard/modulo_ventas/ventas')
      //   // }
      //   if (status === 'DELIVERY_NOTE') {
      //     setStatus('REFUND')
      //   } if (status === 'REFUND') {
      //     setStatus('DELIVERY_NOTE')
      //   }
      // }
      // })
    )
    return () => {
      setHeaderActions(null)
    }
  }, [
    setHeaderActions,
    selectedClient,
    selectedMethods,
    selectedItems,
    isFreeForm,
    status,
  ])

  const getItemsFromValue = async (): Promise<void> => {
    if (itemToSearch !== '') {
      let response = await axios.get<{ existences: IExistencesResponse[] }>(
        `${server}/inventory/existence/search/custom/1?searchCustom=${itemToSearch}`
      )
      if (response.data.existences.length === 0) {
        addAlert({
          message: 'No hay productos',
          status: 'error',
        })
      } else {
        setItemsSearched(response.data.existences)
        setShowModalItems(true)
      }
    } else {
      setShowModalItems(false)
    }
  }

  const onDeleteItemsSelected = async (
    item: IItem & { amount: string },
    idx: number
  ): Promise<void> => {
    console.log('ENTRA', item)
    console.log('idx', idx)
    if (status === 'PENDING') {
      console.log('primer if...')
      try {
        await axios.delete(`${server}/business/sale/pending/${selldId}`, {
          data: { ids: [item.id] },
        })
        //@ts-ignore
        setSelectedItems((prevState) => [
          ...(prevState ? prevState.filter((_, i) => i !== idx) : []),
        ])
      } catch (err) {
      } finally {
      }
    } else if (
      status === 'PENDING_DELIVERY' ||
      status === 'DELIVERY_NOTE_TO_SALE'
    ) {
      console.log('ENTRA', item)
      console.log('idx', idx)
      console.log('segundo if...')
      try {
        await axios.delete(
          `${server}/business/delivery-note/pending/${selldId}`,
          { data: { ids: [item.id] } }
        )
        //@ts-ignore
        setSelectedItems((prevState) => [
          ...(prevState ? prevState.filter((_, i) => i !== idx) : []),
        ])
      } catch (err) {
      } finally {
      }
    } else {
      console.log('tercer if')
      //@ts-ignore
      setSelectedItems((prevState) => [
        ...(prevState ? prevState.filter((_, i) => i !== idx) : []),
      ])
    }
  }

  const onSubmit = async (values: any): Promise<void> => {
    const _values: { client: Omit<IClient, 'id'> } = values
    const fd = new FormData()

    if (values.clientFile) {
      fd.append('media', values.clientFile)
      fd.append('fileType', 'pdf')
      try {
        addAlert({
          message: 'Creando cliente y subiendo imagen',
          status: 'loading',
        })
        await dispatch(createClient(_values, true, fd))
        await onSearchClient(values?.document?.document, true)
        addAlert({
          message: 'Imagen y cliente creados satisfactoriamente',
          status: 'success',
        })
      } catch (err) {
        addAlert({
          message: 'Error al subir imagen o crear cliente',
          status: 'error',
        })
      } finally {
        // setAlreadySelled(true)
        setShowAddClient(false)
      }
      return
    }

    /* usar try catch */
    try {
      addAlert({
        message: 'Creando cliente...',
        status: 'loading',
      })
      await dispatch(createClient(_values))
      await onSearchClient(values?.document?.document, true)
      addAlert({
        message: 'Cliente creado con éxito',
        status: 'success',
      })
    } catch (err) {
      addAlert({
        message: 'Error al crear cliente',
        status: 'error',
      })
    } finally {
      // setAlreadySelled(true)
      setShowAddClient(false)
    }
  }

  /**
   * Calcula la deuda pendiente (sub-total + exento – métodos seleccionados).
   * Si el resultado es negativo se fuerza a 0.
   */
  const getDebt = (): number => {
    const subTotal = new Decimal(sumOfValues('sub_total')) // Bs
    const iva = new Decimal(sumOfValues('iva')) // Bs

    // Total abonado en los métodos seleccionados
    const paid = selectedMethods.reduce(
      (acc, m) => acc.plus(new Decimal(m.amount)),
      new Decimal(0)
    )

    const debt = subTotal.plus(iva).minus(paid) // Bs

    // Si la deuda es negativa, mostramos 0; de lo contrario redondeamos a 2 dec.
    return debt.lessThan(0) ? 0 : debt.toDecimalPlaces(2).toNumber()
  }

  const goBack = (): void => {
    setIsFirstRender(true)
    if (!isPaymentMethod && selectedClient) {
      setSelectedItems([])
      setSelectedClient(null)
    }
    if (isPaymentMethod) {
      setIsPaymentMethod(false)
    }
    setSelectedMethod(null)
    setIgtfAmount(0)
  }

  const cancelSale = async (): Promise<void> => {
    if (c2pMode) {
      setC2pMode(false)
    } else {
      await getRate()
      setSelectedItems([])
      setIgtfAmount(0)
      setSelectedMethods([])
      setSelectedClient(null)
      setIsPaymentMethod(false)
      setAlreadySelled(false)
      setIsCashOut(true)
      setIsFirstRender(true)
      setC2pMode(false)
      // setSeconds(5 * 60)
    }
  }

  const onPressRow = async (item: any): Promise<void> => {
    let idx = selectedItems?.findIndex((v) => v.id === item.id)

    if (status === 'PENDING' || status === 'PENDING_DELIVERY') {
      await axios.patch(
        `${server}/business/${
          status === 'PENDING' ? 'sale' : 'delivery-note'
        }/pending/${selldId}`,
        {
          unload: {
            destination: {
              id: 1,
              locationType: 'warehouse',
            },
            items: [
              {
                idItem: item.item.id,
                amount: '1',
              },
            ],
          },
        }
      )
      if (idx === -1) {
        //@ts-ignore
        setSelectedItems((prevState) => [...prevState, { amount: 1, ...item }])
      } else {
        let copyItems = [...selectedItems]
        copyItems[idx === undefined ? 0 : idx].amount =
          +copyItems[idx === undefined ? 0 : idx].amount + 1
        setSelectedItems(copyItems)
      }
      setSearchItems([])
    } else {
      if (idx === -1) {
        console.log('llega aca 1...')
        const { unit, quantity, inCatalog, description, ...rest } = item
        //@ts-ignore
        setSelectedItems((prevState) => [
          ...prevState,
          { amount: '1', ...item },
        ])
      } else {
        console.log('llega aca 2...')
        let copyItems = [...selectedItems]
        copyItems[idx === undefined ? 0 : idx].amount =
          +copyItems[idx === undefined ? 0 : idx].amount + 1
        setSelectedItems(copyItems)
      }
      setSearchItems([])
    }
  }

  useEffect(() => {
    if (showAddClient) {
      setShowAddClient(false)
      setSelectedClient(clients[clients.length - 1])
    }
  }, [clients])

  useEffect(() => {
    getItemsFromValue()
  }, [itemToSearch])

  useEffect(() => {
    // setAccounts((prevState) => [...prevState.filter((v) => v.accountVisible)])
  }, [])

  useEffect(() => {
    dispatch(fectchAccounts())
  }, [])

  // useEffect(() => {
  //   console.log("folter..", accountsFilter)
  // }, [accountsFilter])

  useEffect(() => {
    if (selectedMethod) {
      if (selectedMethod.accountType === accountTypeEnum.CREDIT) {
        setIsCashOut(false)
      } else {
        setShowMethod((prevState) => !prevState)
      }
    }
  }, [selectedMethod])

  // const onDeletePayment = (idx: number) => {
  //   setSelectedMethods((prevState) => [
  //     ...prevState.filter((prev, index) => index !== idx),
  //   ])
  // }
  const getCurrentDate = () => {
    let days = {
      Mon: 'Lunes',
      Tue: 'Martes',
      Wed: 'Miércoles',
      Thu: 'Jueves',
      Fri: 'Viernes',
      Sat: 'Sábado',
      Sun: 'Domingo',
    }

    let months = {
      Jan: 'Enero',
      Feb: 'Febrero',
      Mar: 'Marzo',
      Apr: 'Abril',
      May: 'Mayo',
      Jun: 'Junio',
      Jul: 'Julio',
      Aug: 'Agosto',
      Sep: 'Septiembre',
      Oct: 'Octubre',
      Nov: 'Noviembre',
      Dec: 'Diciembre',
    }

    const [day, month, year] = saleDate.split('/')

    let currentDate = (new Date(+year, +month - 1, +day) + '').split(' ')
    return (
      <>{`${days[currentDate[0]]}, ${currentDate[2]} de ${
        months[currentDate[1]]
      } del ${currentDate[3]}`}</>
    )
  }

  const onGetCloseBox = async () => {
    let auditBody = null
    let userInfo = null
    if (selectedAccount?.value) {
      const [response, userInfoResponse] = await Promise.all([
        axios.get(`${server}/cash-audit?accountId=${selectedAccount?.value}`),
        axios.get(`${server}/user/tenant`),
      ])
      auditBody = response.data.cashAudit
      userInfo = userInfoResponse?.data?.tenant
    } else {
      const [response, userInfoResponse] = await Promise.all([
        axios.get(`${server}/cash-audit`),
        axios.get(`${server}/user/tenant`),
      ])
      auditBody = response.data.cashAudit
      userInfo = userInfoResponse?.data?.tenant
    }

    const blob = await pdf(
      <AuditPDF auditBody={auditBody} userInfo={userInfo} />
    ).toBlob()

    saveAs(blob, 'Cierre_de_caja')
  }

  useEffect(() => {
    if (c2pMode) {
      const interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1)
        } else {
          updateValidated()
            .then((res) => {
              clearInterval(interval)
              setC2pMode(false)
            })
            .catch((err) => {
              addAlert({
                message: 'Error al actualizar el pago',
                status: 'error',
              })
            })
        }
      }, 1000)

      return () => {
        clearInterval(interval)
      }
    }
  }, [c2pMode, seconds])

  useEffect(() => {
    if (!c2pMode) {
      setSeconds(5 * 60)
    }
  }, [c2pMode])

  const updateValidated = async () => {
    try {
      let response = await axios.patch(
        `${server}/user-payment?id=${paymentId}`,
        { id: paymentId, cancelled: true }
      )
    } catch (err) {
      throw err
    }
  }

  const checkPayment = async () => {
    const [response, response1] = await Promise.all([
      axios.get(`${server}/user-payment?id=${paymentId}`),
      axios.get(`${server}/config/tenant`),
    ])
    // let response = await axios.get(`${server}/user-payment?id=${paymentId}`)
    if (response?.data?.payment?.validated) {
      addAlert({
        message: 'Pago realizado satisfactoriamente',
        status: 'success',
      })
      setC2pMode(false)

      const today = DateTime.local().setLocale('es')

      let date = today.toISODate()

      let newPayment = {
        amount: amountC2p,
        reference: response?.data?.payment?.ref || '',
        currency: {
          id: '2',
        },
        account: {
          id: response1?.data?.userConf?.c2pAccountId,
        },
        date,
        type: 'C2P',
        rate: '1',
      }

      setSelectedMethods((prevState) => [...prevState, newPayment])
    }
  }

  useEffect(() => {
    if (c2pMode) {
      const interval = setInterval(() => {
        checkPayment()
      }, 5000)

      return () => {
        clearInterval(interval)
      }
    }
  }, [c2pMode])

  const onGetTenantConfig = async () => {
    let resp = await axios.get(`${server}/config/tenant`)
    setTenantConfig(resp.data.userConf)
  }

  useEffect(() => {
    onGetTenantConfig()
  }, [])

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60)
    const seconds = timeInSeconds % 60

    return `0${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  }

  const renderInputOptional = () => {
    if (isPaymentMethod) {
      return (
        <div className="flex flex-col justify-between">
          {isCashOut && (
            <>
              <div className="flex justify-between items-center">
                <div className="flex items-center">
                  {!alreadySelled && !c2pMode && (
                    <Button
                      classes="border-none"
                      onClick={() => goBack && goBack()}
                      type="arrow"
                      warehouseType="WAREHOUSE"
                    >
                      <FaArrowLeft size={30} />
                    </Button>
                  )}
                  {!c2pMode && <h1 className="text-sm">MÉTODOS DE PAGO</h1>}
                </div>

                {(userRole === 'admin' ||
                  userRole === 'general_manager' ||
                  userRole === 'master') && (
                  <div style={{ display: c2pMode ? 'none' : 'inherit' }}>
                    <Datepicker
                      onChangeDate={async (value) => {
                        let valueDb = dateToDB(value)
                        // console.log("FECHA", dateToDB(value))
                        await getRate(valueDb, false)
                        const [day, month, year] = value.split('/')
                        let valueDate = DateTime.fromISO(valueDb)
                        let todayIso = DateTime.fromISO(
                          today.toFormat('yyyy-MM-dd')
                        )
                        // console.log("vlaue date", valueDate)
                        // console.log("today iso", todayIso)
                        // console.log("")
                        if (valueDate > todayIso) {
                          setSaleDate(today.toFormat('d/M/yyyy'))
                          addAlert({
                            message:
                              'La fecha de venta no puede ser mayor a la fecha actual',
                            status: 'error',
                          })
                          setIsDisableForDay(true)
                          return
                        }
                        setIsDisableForDay(false)
                        setSaleDate(
                          `${+day < 10 ? +day : day}/${
                            +month < 10 ? +month : month
                          }/${year}`
                        )
                      }}
                      label="Fecha venta"
                      defaultValue={saleDate}
                    />
                  </div>
                )}

                {/* {selectedClient && +selectedClient.credit > 0 && (
              <div
                className="flex h-full items-center text-warning-light cursor-pointer"
                onClick={() =>
                  setSelectedMethod({
                    name: 'Crédito',
                    icon: null,
                    accountType: accountTypeEnum.CREDIT,
                  })
                }
              >
                Pagar con crédito
              </div>
            )} */}

                {/* {status !== 'DELIVERY_NOTE' && (
              <h1 className="text-sm text-primary">
                {isFreeForm ? 'Forma libre' : 'Factura'}
              </h1>
            )} */}
              </div>

              <div className={!c2pMode ? `grid grid-cols-2 gap-3 h-3/6` : ``}>
                {c2pMode && (
                  <div className="grid gap-3">
                    <div className="col-span-12">
                      <div
                        style={{
                          backgroundColor: '#f6fbff',
                          borderRadius: 10,
                          padding: 10,
                        }}
                        className="flex flex-row justify-between justify-items-center"
                      >
                        <label
                          style={{ color: '#70889e' }}
                        >{`${window.location.origin}/pago_en_linea?id=${paymentId}`}</label>
                        <Tooltip title="Copiar link">
                          <MdOutlineFileCopy
                            style={{ color: '#70889e', cursor: 'pointer' }}
                            onClick={async () => {
                              try {
                                await navigator.clipboard.writeText(
                                  `${window.location.origin}/pago_en_linea?id=${paymentId}`
                                )
                                addAlert({
                                  message: 'Link copiado satisfactoriamente',
                                  status: 'success',
                                })
                              } catch (error) {
                                console.error(
                                  'Falló al copiar el texto: ',
                                  error
                                )
                              }
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>

                    <div className="flex flex-col items-center col-span-12 mt-5">
                      <img src={qrCode} style={{ height: 150, width: 150 }} />

                      <div>
                        <div
                          className="mt-3"
                          style={{
                            backgroundColor: '#dee7f3',
                            padding: 10,
                            borderRadius: 8,
                          }}
                        >
                          <label style={{ color: '#2f7ee4', fontWeight: 900 }}>
                            {formatTime(seconds)}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {!c2pMode &&
                  [
                    {
                      name: 'Efectivo',
                      icon: AiOutlineWallet,
                      accountType: accountTypeEnum.CASH,
                    },
                    {
                      name: 'Tarjeta',
                      icon: BsCreditCard,
                      accountType: accountTypeEnum.CARD,
                    },
                    {
                      name: 'Transferencia o Pago Móvil',
                      icon: BiTransfer,
                      accountType: accountTypeEnum.BANKACCOUNT,
                    },
                    {
                      name: 'Otros Pagos',
                      icon: GiReceiveMoney,
                      accountType: accountTypeEnum.WALLET,
                    },
                    // {
                    //   name: 'ZELLE',
                    //   icon: null,
                    //   accountType: accountTypeEnum.ZELLE,
                    // },
                    // {
                    //   name: 'PAGO EN LÍNEA (C2P)',
                    //   icon: MdMoney,
                    //   accountType: accountTypeEnum.C2P,
                    // },
                    // {
                    //   name: 'IGTF',
                    //   icon: FaPercent,
                    //   accountType: accountTypeEnum.IGTF,
                    // },
                    {
                      name: 'Venta A Crédito',
                      icon: FaCreditCard,
                      accountType: accountTypeEnum.CREDIT,
                    },
                    {
                      name: 'Retenciones',
                      icon: BiMinus,
                      accountType: accountTypeEnum.RETENTION,
                    },
                    // {
                    //   name: 'Pago móvil',
                    //   icon: AiFillMobile,
                    //   accountType: accountTypeEnum.PAGO_MOVIL,
                    // },
                  ]
                    .filter((paymentMethod) => {
                      // Retenciones solo disponible para planes corporativo y pyme
                      if (paymentMethod.accountType === accountTypeEnum.RETENTION) {
                        return userPlan === 'corporativo' || userPlan === 'pyme'
                      }
                      return true
                    })
                    .map((paymentMethod) => (
                    <div
                      // style={{ maxHeight: '40%', marginTop: '3%' }}
                      className={`bg-light-200 dark:bg-gray-800 rounded-lg flex justify-center ${
                        !alreadySelled && 'cursor-pointer'
                      }`}
                      onClick={async () => {
                        // console.log("payment method", paymentMethod)
                        !alreadySelled && setSelectedMethod(paymentMethod)
                      }}
                    >
                      <div className="flex h-full items-center">
                        <div className="mr-2 h-8 w-8 dark:bg-black bg-light-300 rounded-3xl flex justify-center items-center">
                          {paymentMethod.icon ? (
                            <paymentMethod.icon color="#006AEA" />
                          ) : (
                            <img
                              style={{ width: 13, height: 20 }}
                              src={
                                require('../../assets/images/zelle-blue.png')
                                  .default
                              }
                            />
                          )}
                        </div>
                        <div
                          className={`${
                            windowSize.innerWidth < 1200 && 'truncate w-32'
                          }`}
                        >
                          {paymentMethod.name}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              <div
                className="overflow-y-auto"
                style={{ maxHeight: '20%', marginTop: '3%' }}
              >
                {selectedMethods.map((method, index) => (
                  <div
                    className="bg-gray-100 dark:bg-gray-800 rounded-lg mt-4 p-2 flex justify-between items-center"
                    key={index}
                  >
                    <div>
                      {/* {!alreadySelled && ( */}
                      <Button classes="border-none">
                        <FiTrash2
                          size={20}
                          color="red"
                          onClick={() => {
                            setSelectedMethods((prev) => {
                              const methodToDelete = prev[index]

                              // If the deleted payment is in USD, clear the IGTF
                              if (methodToDelete?.currency?.id === '1') {
                                setIgtfAmount(0)
                              }

                              // Return the filtered list without the deleted item
                              return prev.filter((_, i) => i !== index)
                            })
                          }}
                        />
                      </Button>
                      {/* )} */}
                    </div>

                    <div className="flex">
                      {/* {console.log("vuelto",)} */}
                      {method.type} : {getDenomination(method?.currency?.id)}{' '}
                      {formatPipe(toFixed(+method.amount, 2).replace('.', ','))}
                    </div>
                  </div>
                ))}

                {/* Mostrar retenciones agregadas */}
                {selectedRetentions.map((retention, index) => (
                  <div
                    className="bg-orange-100 dark:bg-orange-900 rounded-lg mt-4 p-2 flex justify-between items-center"
                    key={`retention-${index}`}
                  >
                    <div>
                      <Button classes="border-none">
                        <FiTrash2
                          size={20}
                          color="red"
                          onClick={() => {
                            setSelectedRetentions((prev) =>
                              prev.filter((_, i) => i !== index)
                            )
                          }}
                        />
                      </Button>
                    </div>

                    <div className="flex">
                      Retención {retention.retentionType} : Bs{' '}
                      {formatPipe(toFixed(+retention.amount, 2).replace('.', ','))}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ marginTop: '10%' }}>
                <div className="flex w-full justify-between">
                  <h1 className="text-sm">TOTAL INGRESADO</h1>
                  <h1 className="text-sm text-green-600">
                    Bs{' '}
                    {formatPipe(
                      toFixed(
                        selectedMethods
                          .reduce(
                            (acc, method) =>
                              acc.plus(
                                new Decimal(method.amount).mul(method.rate)
                              ),
                            new Decimal(0)
                          )
                          .plus(isHigherState ? debt : 0)
                          .toDecimalPlaces(2)
                          .toNumber(),
                        2
                      )
                      // selectedMethods
                      //   .reduce(
                      //     (a, b) => a + +(+b.amount * +b.rate).toFixed(2),
                      //     0
                      //   )
                      //   .toFixed(2)
                    )}
                  </h1>
                </div>

                <div className="flex w-full justify-between">
                  <h1 className="text-sm">DEUDA</h1>
                  <h1 className="text-sm text-red-600">
                    Bs{' '}
                    {status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? formatPipe(
                          getDebt() > 0 ? getDebt().toFixed(2) : '0,00'
                        )
                      : isHigherState
                      ? '0,00'
                      : /* ⬇️ aquí la única línea cambiada */
                      +debt > 0
                      ? formatPipe(debt, false, 2, -999999999)
                      : '0,00'}
                  </h1>
                </div>

                <div className="flex w-full justify-between">
                  <h1 className="text-sm">VUELTO</h1>
                  <h1 className="text-sm text-primary">
                    Bs {formatPipe(onGetChange())}
                  </h1>
                </div>
              </div>
            </>
          )}

          {!isCashOut && (
            <div>
              <div className="flex items-center mb-3">
                <Button
                  classes="border-none"
                  onClick={() => {
                    setIsCashOut(true)
                    setCredit(null)
                  }}
                  type="arrow"
                  warehouseType="WAREHOUSE"
                >
                  <FaArrowLeft size={30} />
                </Button>
                <h1 className="text-sm">Ir a pagos de contado</h1>
              </div>
              <CreditSaleForm onSubmit={setCredit} />
            </div>
          )}

          {/* <Button type="primary" onClick={() => onCreatePendingSell()}>
                Pendiente
              </Button> */}

          {/* <div className="h-3/6 flex flex-col justify-between mt-3">
          {['Efectivo', 'Tarjeta', 'Transferencia', 'Tarjeta de regalo'].map(paymentMethod => (
            <div className="dark:bg-gray-800 rounded-lg h-1/5">
              {paymentMethod}
            </div>
          ))}
        </div> */}
        </div>
      )
    }
    if (selectedClient) {
      return (
        <div>
          <div className="flex justify-between w-full mb-5">
            <Button
              classes="border-none"
              onClick={() => goBack && goBack()}
              type="arrow"
              warehouseType="WAREHOUSE"
            >
              <FaArrowLeft size={30} />
            </Button>

            <div className="flex justify-between w-7/12">
              <div className="w-9/12">
                <input
                  type="text"
                  className="dark:bg-gray-800 dark:text-white mt-1 mb-2 h-7"
                  name="code"
                  placeholder="INGRESE EL CÓDIGO O NOMBRE DEL PRODUCTO"
                  autoComplete="off"
                  ref={refCode}
                  onKeyDown={(e) => e.key === 'Enter' && onSearchItem()}
                />
              </div>
              {/* <div className="w-2/12">
            <input
              type="text"
              className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
              name="quantity"
              placeholder="Ingrese cantidad"
              autoComplete="off"
              ref={refQuantity}
            />
           </div> */}
              <div>
                <Button type="primary" onClick={() => onSearchItem()}>
                  Buscar
                </Button>
              </div>
            </div>
          </div>
          {/* Tabla de productos en venta. */}
          <div style={{ height: '350px', width: '100%' }}>
            <Table
              columns={columnsSearchInSell}
              evaluateNegativeRow={true}
              data={searchItems}
              showPagination={false}
              onPressButton={async (item: IExistenceInSale) => {
                onPressRow(item)
                // if (item.item.price.length === 0) {
                //   addAlert({
                //     message: 'Este producto no tiene precio',
                //     status: 'error',
                //   })
                // } else {
                //   onPressRow(item)
                // }
              }}
            />
          </div>
        </div>
      )
    }
    return (
      <div>
        {status === 'PENDING' && (
          <div>
            <div className="flex justify-between w-full mb-5">
              <Button
                classes="border-none"
                onClick={() => onGoBack && onGoBack()}
                type="arrow"
                warehouseType="WAREHOUSE"
              >
                <FaArrowLeft size={30} />
              </Button>

              <div className="flex justify-between w-8/12">
                <div className="w-7/12">
                  {/* <input
                    type="text"
                    className="dark:bg-gray-800 dark:text-white mt-1 h-7"
                    name="cedula"
                    placeholder="Ingrese cédula del cliente"
                    autoComplete="off"
                    ref={refDocument}
                    onChange={(e) => {
                      console.log('e valor', e)
                      if (/^[vjepgc]$/gi.test(e.target.value)) {
                        refDocument.current &&
                          (refDocument.current.value = `${e.target.value.toUpperCase()}-`)
                      }
                    }}
                    onKeyDown={(e) => {
                      console.log('e', e)
                      if (
                        e.key === 'Backspace' &&
                        /^[vjepgc]-$/gi.test(
                          (refDocument.current && refDocument.current.value) ||
                            ''
                        )
                      ) {
                        refDocument.current && (refDocument.current.value = '')
                      }
                    }}
                  />
                  {<p className="text-danger mt-3">{error || ''}</p>} */}
                  <AdvancedSearch
                    onEnter={(values) => {
                      console.log('valor...', values)
                      refInputAdvanced.current = null
                    }}
                    ref={refInputAdvanced}
                  />
                </div>
                <div>
                  <Button type="primary" onClick={() => onSearchClient()}>
                    Buscar
                  </Button>
                </div>

                <div>
                  <Button type="primary" onClick={() => setShowAddClient(true)}>
                    Añadir
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {status != 'PENDING' && (
          <div className="flex justify-between w-full mb-5">
            <div className="w-7/12">
              {/* <input
                type="text"
                className="dark:bg-gray-800 dark:text-white mt-1 h-7"
                name="cedula"
                placeholder="Ingrese cédula del cliente"
                autoComplete="off"
                ref={refDocument}
                onChange={(e) => {
                  onSearchClient()
                  if (/^[vjepgc]$/gi.test(e.target.value)) {
                    console.log('llegando...', e.target.value)
                    refDocument.current &&
                      (refDocument.current.value = `${e.target.value.toUpperCase()}-`)
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onSearchClient()
                  }
                  if (
                    e.key === 'Backspace' &&
                    /^[vjepgc]-$/gi.test(
                      (refDocument.current && refDocument.current.value) || ''
                    )
                  ) {
                    refDocument.current && (refDocument.current.value = '')
                  }
                }}
              />
              {<p className="text-danger mt-3">{error || ''}</p>} */}
              <AdvancedSearch
                placeholder="INGRESE NRO. DOCUMENTO CLIENTE"
                onEnter={(values) => {
                  console.log('valor...', values)
                  onSearchClient(values)
                  if (refInputAdvanced && refInputAdvanced.current) {
                    console.log('llega..')
                    refInputAdvanced.current.value = ''
                  }
                }}
                ref={refInputAdvanced}
              />
            </div>
            <div>
              <Button
                type="primary"
                classes="rounded"
                onClick={() => onSearchClient()}
              >
                Buscar
              </Button>
            </div>

            <div>
              <Button
                classes="rounded"
                type="primary"
                onClick={() => setShowAddClient(true)}
              >
                Añadir Cliente
              </Button>
            </div>
          </div>
        )}

        <Table
          applyBackgroundHover={true}
          columns={columnsSearchClients}
          data={searchClient}
          showPagination={false}
          onPressButton={(client) => {
            setSearchClient([])
            setSelectedClient(client)
          }}
        />
      </div>
    )
  }

  const onUpdateItem = (idx: number): void => {
    //@ts-ignore
    let items = [...selectedItems]
    items[idx].enableEdit = true
    setSelectedItems(items)
  }

  const onSaveUpdateItem = async (
    item: IItem & { amount: string; enableEdit: boolean; id_item_sale: string },
    idx: number
  ): Promise<void> => {
    console.log('ITEM', item)
    await axios.patch(
      `${server}/business/${
        status === 'PENDING' ? 'sale' : 'delivery-note'
      }/pending/amount/${item.id_item_sale}`,
      { amount: item.amount }
    )
    //@ts-ignore
    let items = [...selectedItems]
    items[idx].enableEdit = false
    setSelectedItems(items)
  }

  const calculateIgtf = (methods: any[]): Decimal => {
    if (methods.length === 0) {
      setIgtfAmount(0)
      return new Decimal(0)
    }

    // get the method with currency id 1 (USD) and calcualte it to bs then multiply it by 3%
    const usdMethod = methods.find((m) => m.currency?.id === '1')

    if (usdMethod) {
      const amountInBs = new Decimal(usdMethod.amount).mul(usdMethod.rate)

      if (
        amountInBs.isNaN() ||
        amountInBs.isNegative() ||
        amountInBs.isZero()
      ) {
        setIgtfAmount(0)
        return new Decimal(0)
      }

      const total = new Decimal(
        sumOfValues('sub_total') + sumOfValues('iva')
      ).toDecimalPlaces(2)
      console.log(
        'Subtotal + IVA:',
        total.toNumber(),
        'Amount in Bs (USD method):',
        amountInBs.toNumber()
      )

      if (amountInBs.lte(total)) {
        const igtf = amountInBs.mul(0.03).toDecimalPlaces(2)
        console.log('IGTF Amount:', igtf.toNumber())
        setIgtfAmount(igtf.toNumber())
        return igtf
      } else {
        const igtf = total.mul(0.03).toDecimalPlaces(2)
        console.log('IGTF Amount:', igtf.toNumber())
        setIgtfAmount(igtf.toNumber())
        return igtf
      }
    }

    // If no USD method, return 0
    setIgtfAmount(0)
    return new Decimal(0)
  }

  const handleIncludeIgtfInUsdPayment = () => {
    if (selectedMethods.length === 0) {
      return
    }

    const usdMethod = selectedMethods.find((m) => m.currency?.id === '1')

    if (usdMethod) {
      const igtf = new Decimal(igtfAmount)

      if (igtf.isZero()) {
        console.warn('IGTF amount is zero, not updating USD method')
        return
      }

      const igtfInUsd = igtf.div(usdMethod.rate).toDecimalPlaces(2)

      console.log('IGTF in USD:', igtfInUsd.toNumber())

      const newAmount: number = new Decimal(usdMethod.amount)
        .plus(igtfInUsd)
        .toDecimalPlaces(2)
        .toNumber()

      console.log('New USD Method Amount:', newAmount)

      const newMethod = {
        ...usdMethod,
        amount: toFixed(newAmount, 2),
      }

      setSelectedMethods((prevState) =>
        prevState.map((m) => (m === usdMethod ? newMethod : m))
      )
    }
  }

  const onSelectMethod = async (
    method: any,
    type: accountTypeEnum
  ): Promise<void> => {
    setShowMethod(false)

    let obj = {
      [accountTypeEnum.BANKACCOUNT]: 'Cuenta Bancaria',
      [accountTypeEnum.CARD]: 'Punto de venta',
      [accountTypeEnum.CASH]: 'Efectivo',
      [accountTypeEnum.WALLET]: 'Internacional/Otros',
      [accountTypeEnum.mobilePayment]: 'Pago Móvil',
      [accountTypeEnum.nationalTransfer]: 'Cuenta Bancaria',
      [accountTypeEnum.CREDIT]: 'Crédito',
      [accountTypeEnum.C2P]: 'C2P',
      [accountTypeEnum.ZELLE]: 'Zelle',
      [accountTypeEnum.PAGO_MOVIL]: 'Pago Móvil',
      [accountTypeEnum.RETENTION]: 'Retención',
    }

    const today = DateTime.local().setLocale('es')

    let date = today.toISODate()

    // Manejo de retenciones
    if (type === accountTypeEnum.RETENTION) {
      // Validar que el cliente tenga todos los datos necesarios
      if (!selectedClient) {
        addAlert({
          message: 'Debe seleccionar un cliente para agregar retenciones',
          status: 'error',
        })
        return
      }

      const missingFields: string[] = []
      if (!selectedClient.email) missingFields.push('correo electrónico')
      if (!selectedClient.address) missingFields.push('dirección')
      if (!selectedClient.document) missingFields.push('documento de identidad')

      if (missingFields.length > 0) {
        addAlert({
          message: `El cliente debe tener los siguientes datos: ${missingFields.join(', ')}`,
          status: 'error',
        })
        return
      }

      // Validar formato de documento (V/J/E/G/C + dígitos)
      const documentRegex = /^[VJEGC]\d{5,}$/i
      const fullDocument = `${selectedClient.documentType}${selectedClient.document}`
      if (!documentRegex.test(fullDocument)) {
        addAlert({
          message: 'El documento del cliente debe tener formato válido (ej: V12345678, J301234567)',
          status: 'error',
        })
        return
      }

      // Crear objeto de retención
      const newRetention = {
        retentionType: method.retentionType, // 'IVA' o 'ISLR'
        amount: method.amount, // Monto retenido
        ...method, // Todos los demás campos del formulario
      }

      setSelectedRetentions((prev) => [...prev, newRetention])

      addAlert({
        message: `Retención ${method.retentionType} agregada exitosamente`,
        status: 'success',
      })

      return
    }

    if (type === accountTypeEnum.PAGO_MOVIL) {
      let configResponse = await axios.get(`${server}/config/tenant`)

      if (!configResponse.data.userConf.pmAccountId) {
        addAlert({
          message: 'Debe de agregar su cuenta de pago movil de destino',
          status: 'error',
        })
        return
      }

      if (!configResponse.data.userConf.pmClientId) {
        addAlert({
          message: 'Debe de agregar el rif de destino.',
          status: 'error',
        })
        return
      }

      if (method?.isManual) {
        let newPayment = {
          amount: method.amount,
          reference: method?.ref,
          currency: {
            id: '2',
          },
          account: {
            id: configResponse?.data?.userConf?.pmAccountId,
          },
          date,
          type: obj[type],
          rate: '1',
        }

        setSelectedMethods((prevState) => [...prevState, newPayment])

        return
      }

      try {
        if (!configResponse.data.userConf.pmAccountId) {
          addAlert({
            message: 'Debe de agregar su cuenta de pago movil de destino',
            status: 'error',
          })
          return
        }

        if (!configResponse.data.userConf.pmClientId) {
          addAlert({
            message: 'Debe de agregar el rif de destino.',
            status: 'error',
          })
          return
        }

        const { isManual, ...rest } = method

        let body = {
          ...rest,
          originNumber: +method?.originNumber.slice(1),
          destinyIdentification: configResponse.data.userConf.pmClientId,
        }

        let resp = await axios.post(`${server}/user-payment/validate-pm`, body)

        if (!resp.data.valid) {
          addAlert({ message: 'Pago no es válido', status: 'error' })
          return
        }

        let newPayment = {
          amount: method.amount,
          reference: method?.ref,
          currency: {
            id: '2',
          },
          account: {
            id: configResponse?.data?.userConf?.pmAccountId,
          },
          date,
          type: obj[type],
          rate: '1',
        }

        setSelectedMethods((prevState) => [...prevState, newPayment])
        addAlert({
          message: 'Pago móvil realizado satisfactoriamente',
          status: 'success',
        })
      } catch (err) {
        addAlert({
          message: 'No se pudo realizar el pago movil',
          status: 'error',
        })
      }
      return
    }

    if (type === accountTypeEnum.CARD) {
      let response = await axios.get(`${server}/cashier`)
      let idAccount = response?.data?.cashiers[0]?.idPosAccount
      if (!idAccount) {
        addAlert({
          message: 'No hay ninguna cuenta asociada a este cajero',
          status: 'error',
        })
        return
      }
      let newPayment = {
        amount: method.amount,
        reference: method.reference,
        currency: {
          id: '2',
        },
        /** Aqui tengo que colocar la cuenta de debito por defecto */
        account: {
          id: idAccount || '1',
        },
        date,
        type: obj[type],
        rate: '1',
      }
      // let isHigher = checkDebt([...selectedMethods, newPayment])
      // setIsHigherState(isHigher)
      setSelectedMethods((prevState) => [...prevState, newPayment])

      return
    }

    if (type === accountTypeEnum.C2P) {
      let configResponse = await axios.get(`${server}/config/tenant`)

      if (!configResponse?.data?.userConf?.c2pAccountId) {
        addAlert({
          message: 'Debe de tener una cuenta asociada a c2p.',
          status: 'error',
        })
        return
      }

      if (!configResponse?.data?.userConf?.c2pClientId) {
        addAlert({
          message: 'Debe de tener un Rif/CI la cuenta asociada.',
          status: 'error',
        })
        return
      }

      let userTenant = await axios.get(`${server}/user/tenant`)
      let body = {
        amount: method?.amount,
        sale: {
          businessSocial: userTenant?.data?.tenant?.businessSocial,
        },
        // sale: {
        //   total: method?.amount,
        //   items: []
        // }
      }

      setAmountC2p(method?.amount)

      const response = await axios.post(`${server}/user-payment`, body)

      let qrCode = await toDataURL(
        `${window.location.origin}/pago_en_linea?id=${response.data?.payment?.id}`
      )

      setQrcode(qrCode)

      setPaymentId(response.data?.payment?.id)

      setC2pMode(true)
      return
    }

    if (type === accountTypeEnum.ZELLE) {
      if (method?.isManual) {
        const tenantInfo = await axios.get(`${server}/config/tenant`)
        let newPayment = {
          amount: method.amount,
          reference: '',
          currency: {
            id: '1',
          },
          account: {
            id: tenantInfo?.data?.userConf?.zelleAccountId,
          },
          date,
          type: obj[type],
          rate: '1',
        }

        // newPayment.amount = +newPayment.rate * +newPayment?.amount || newPayment?.amount

        // if (account.idCurrency !== '2') {
        //   axios.get(`${server}/finances/rate?date=${date}&`)
        // }

        let rate = onGetRate('1')
        // console.log('rate...', rate)
        // let rate = globalRate.find(rate => rate.id === account.idCurrency)

        newPayment.rate = rate || newPayment.rate

        // console.group('new payment', newPayment)

        // let isHigher = checkDebt([...selectedMethods, newPayment])
        // setIsHigherState(isHigher)

        setSelectedMethods((prevState) => [...prevState, newPayment])

        return
      }

      addAlert({
        message: 'Validando Pago...',
        status: 'loading',
      })
      //Oauth
      if (tokenClient) {
        tokenClient.callback = async (resp) => {
          //@ts-ignore
          const token = gapi.client.getToken()
          let body = {
            name: method?.name?.split(' ')[0],
            amount: method?.amount.toFixed(2),
            token: token?.access_token,
          }
          try {
            // await axios.patch(`${server}/config/tenant`
            // await axios.post(`${server}/validate-zelle`, body)

            const [tenantInfo, zelleResponse] = await Promise.all([
              axios.get(`${server}/config/tenant`),
              axios.post(`${server}/validate-zelle`, body),
            ])

            if (!zelleResponse.data?.valid) {
              addAlert({ message: 'Zelle no es válido', status: 'error' })
              return
            }

            addAlert({
              message: 'Pago realizado satisfactoriamente',
              status: 'success',
            })

            // let account = accounts.find(
            //   (account) => account.id === method.type
            // ) as IMoneyAccount

            let newPayment = {
              amount: method.amount,
              reference: '',
              currency: {
                id: '1',
              },
              account: {
                id: tenantInfo?.data?.userConf?.zelleAccountId,
              },
              date,
              type: obj[type],
              rate: '1',
            }

            // newPayment.amount = +newPayment.rate * +newPayment?.amount || newPayment?.amount

            // if (account.idCurrency !== '2') {
            //   axios.get(`${server}/finances/rate?date=${date}&`)
            // }

            let rate = onGetRate('1')
            // console.log('rate...', rate)
            // let rate = globalRate.find(rate => rate.id === account.idCurrency)

            newPayment.rate = rate || newPayment.rate

            // console.group('new payment', newPayment)

            // let isHigher = checkDebt([...selectedMethods, newPayment])
            // setIsHigherState(isHigher)

            setSelectedMethods((prevState) => [...prevState, newPayment])
          } catch (err) {
            addAlert({
              message: 'No se pudo validar el zelle',
              status: 'error',
            })
          }

          if (resp.error !== undefined) {
            throw resp
          }
        }

        //@ts-ignore
        if (gapi.client.getToken() === null) {
          // Prompt the user to select a Google Account and ask for consent to share their data
          // when establishing a new session.
          tokenClient.requestAccessToken({ prompt: 'consent' })
        } else {
          //@ts-ignore
          console.log('client', gapi.client)
          // Skip display of account chooser and consent dialog for an existing session.
          tokenClient.requestAccessToken({ prompt: '' })
        }
      }
      return
    }

    let account = accounts.find(
      (account) => account.id === method.type
    ) as IMoneyAccount

    console.log('account', account)

    let newPayment = {
      amount: method.amount,
      reference: method.reference,
      currency: {
        id: account.idCurrency,
      },
      account: {
        id: method.type,
      },
      date,
      type: obj[type],
      rate: '1',
    }

    let rate = onGetRate(account.idCurrency)
    console.log('rate...', rate)

    newPayment.rate = rate || newPayment.rate

    const yaHayUSD = selectedMethods.some((m) => m?.currency?.id === '1')
    if (yaHayUSD && newPayment?.currency?.id === '1') {
      // mostrar alerta si ya hay un pago en USD
      addAlert({
        message:
          'Ya hay un pago en USD seleccionado. No se puede agregar otro.',
        status: 'error',
        duration: 7000,
      })
      return // ⬅️ abortamos la inserción
    }

    // Si id currency es 1
    if (newPayment?.currency?.id === '1') {
      // calcular igtf
      const calculatedIGTF = calculateIgtf([...selectedMethods, newPayment])

      // setIgtfAmount(calculatedIGTF.toNumber())
      console.log('IGTF Amount:', calculatedIGTF.toNumber())
      // calculate amount in Bs
      const rate = onGetRate('1') // Obtenemos la tasa de cambio para USD
      const amountInBs = new Decimal(newPayment.amount).mul(rate)

      // chequea si el monto es menor por 0.1 al total de la factura
      const total = new Decimal(
        sumOfValues('sub_total') + sumOfValues('iva')
      ).toDecimalPlaces(2)

      // Si amountInBs es un número y todavía falta algo para llegar al total…
      if (!amountInBs.isNaN()) {
        if (amountInBs.lt(total)) {
          console.log('El monto es menor al total')
          // Suma los pagos en bs
          const totalPaidInBs = selectedMethods.reduce((acc, method) => {
            if (method?.currency?.id === '2') {
              return acc.plus(new Decimal(method.amount).mul(method.rate))
            }
            return acc
          }, new Decimal(0))
          // Diferencia entre lo pagado y el total (en bolívares)
          const diff = total.minus(totalPaidInBs).minus(amountInBs) // Decimal

          console.log('Diferencia:', diff.toNumber())

          // ¿La diferencia es de 0,1 Bs o menos?
          if (diff.lte(new Decimal('0.1'))) {
            setShowIgtfModal(true) // mostramos modal IGTF
          }
          // Si diff > 0,1 Bs, no hacemos nada\
        }
        // Si amountInBs es un número y es mayor o igual al total
        else {
          setShowIgtfModal(true)
        }
      }
    }

    setSelectedMethods((prevState) => [...prevState, newPayment])
  }

  const formatRows = () => {
    let array = []
    if (selectedItems) {
      for (let i = 0; i < selectedItems?.length; i++) {
        let arraySub = [
          selectedItems[i].barcode || selectedItems[i].sku,
          selectedItems[i].name,
          selectedItems[i].amount,
        ]
        //@ts-ignore
        array.push(arraySub)
      }
      return array
    }
  }

  const onSubmitCounterFoil = async (values): Promise<void> => {
    const objBody = {
      sale: {
        client: {
          id: selectedClient?.id,
        },
        payments: selectedMethods.map((method) => ({
          idAccount: method.id || '',
          amount: +method.amount,
          details: formatValueToSave(method)?.accountType,
          transactionType: method.type === 'Crédito' ? 'EXPENSES' : 'INCOME',
          receipt: method.ref || '',
          bills: method?.bills,
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          items: selectedItems?.reduce((a, b) => {
            a = [...a, { idItem: b.id, amount: b.amount }]
            if (b.type === 'COMPOUND' && b.compositionCompound) {
              a = [
                ...a,
                ...b.compositionCompound.map((v) => ({
                  idItem: v.item.id,
                  amount: b.amount,
                })),
              ]
            }
            return a
          }, [] as any),
        },
        invoice: {
          // taxPrice: sumOfValues('iva').toFixed(2),
          taxPrice: toFixed(sumOfValues('iva'), 2),
          tax: tax + '',
          // taxBase: sumOfValues('sub_total').toFixed(2),
          taxBase: toFixed(sumOfValues('sub_total'), 2),
          // subTotal:
          //   +sumOfValues('exempt').toFixed(2) +
          //   +sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(
            sumOfValues('exempt') + sumOfValues('sub_total'),
            2
          ),
          // exempt: +sumOfValues('exempt').toFixed(2),
          exempt: toFixed(sumOfValues('exempt'), 2),
          // total:
          //   +sumOfValues('sub_total').toFixed(2) +
          //   +sumOfValues('iva').toFixed(2) +
          //   +sumOfValues('exempt').toFixed(2),
          total: toFixed(
            sumOfValues('sub_total') +
              sumOfValues('iva') +
              sumOfValues('exempt'),
            2
          ),
          invoiceDetail: {
            invoiceNumber: values.invoiceNumber,
            controlNumber: values.controlNumber,
            items: selectedItems,
          },
        },
        deliveryNote: {},
        cashier: 'Gustavo Parra',
        seller: '',
      },
    }

    try {
      await axios.post(`${server}/business/sale/invoice`, {
        sale: objBody.sale,
      })
      setShowModalControlNumber(false)
      addAlert({ message: 'Talonario creado con éxito', status: 'success' })
      setAlreadySelled(true)
    } catch (err) {
      addAlert({
        message: 'Error al crear talonario',
        status: 'error',
      })
    }
  }

  const invoiceMemo = useMemo(() => {
    if (!tenantConfig?.invoiceControl) return ''

    // Convert to string and pad with leading zeros to make it 8 digits
    const paddedNumber = String(tenantConfig.invoiceControl).padStart(8, '0')

    // Format as "00-00000195"
    return `00-${paddedNumber}`
  }, [tenantConfig])

  return (
    <div
      style={{
        height: window.innerHeight - windowSize.innerHeight * 0.2 + 'px',
      }}
    >
      <div
        className={status === 'DELIVERY_NOTE' ? '' : 'h-full'}
        style={{ height: window.innerHeight - 255 + 'px' }}
      >
        {!showPdf && !showPdfDeliveryNote && (
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-4 h-full">
            {/* Left side */}
            {/* <div>
          {renderInputOptional()}
          <div className="flex justify-center">
            <div className="mt-8 grid grid-cols-2 grid-rows-6 gap-6">
              <div className="dark:bg-gray-400 row-span-3 h-16 w-80 rounded-md">
                <h1 className="text-sm">Efectivo</h1>
              </div>
              <div className="dark:bg-gray-400 row-span-3 w-80 rounded-md">
                <h1 className="text-sm">Tarjeta</h1>
              </div>
              <div className="dark:bg-gray-400 row-span-3 w-80 rounded-md">
                <h1 className="text-sm">Transferencia</h1>
              </div>
              <div className="dark:bg-gray-400 row-span-3 w-80 rounded-md">
                <h1 className="text-sm">Tarjeta de regalo</h1>
              </div>
            </div>
          </div>

          <div className="h-3/6 mt-5">
            <h1>Aqui va mapeo de metodos de pagos.</h1>
          </div>

          <div className="flex justify-center">
            <div className="flex justify-between w-4/12">
              <Button type="primary" onClick={() => onCreateSell()}>
                Continuar
              </Button>
              <Button type="outline">Cancelar</Button>
            </div>
          </div>
        </div> */}

            <div className="h-full">
              <div
                className="bg-light-100 dark:bg-black flex rounded-2xl p-4 grid"
                style={{
                  height: '90%',
                  overflow: isPaymentMethod ? 'visible' : 'scroll',
                }}
              >
                {renderInputOptional()}
              </div>

              <div
                className="flex justify-center items-end"
                style={{ height: '10%' }}
              >
                {(alreadySelled && status !== 'DELIVERY_NOTE_TO_SALE') ||
                (alreadySelled &&
                  status === 'DELIVERY_NOTE_TO_SALE' &&
                  finishedDeliveryToSale) ? (
                  <div>
                    <Button type="primary" onClick={() => cancelSale()}>
                      {alreadySelled &&
                      (status === 'DELIVERY_NOTE' ||
                        status === 'PENDING_DELIVERY')
                        ? 'Nueva nota de entrega'
                        : 'Nueva venta'}
                    </Button>
                  </div>
                ) : (
                  <div className="flex justify-between lg:w-6/12 xl:w-4/12">
                    {/* <Button classes="text-white border-none dark:text-white dark:hover:text-white dark:focus:text-white hover:text-white focus:text-white bg-gradient-to-bl from-primary to-primary-dark dark:hover:bg-primary focus:bg-primary dark:focus:bg-primary" onClick={() => {
                // onCreateSell()
                setIsPaymentMethod(true)
                }}
                >
                Continuar
              </Button> */}
                    <Button type="outline" onClick={() => cancelSale()}>
                      Cancelar
                    </Button>

                    <button
                      onClick={() => {
                        const total = +toFixed(getTotalAmount(false), 2)

                        if (total < discountValue) {
                          addAlert({
                            message: 'El descuento no puede ser mayor al total',
                            status: 'error',
                          })
                          return
                        }

                        if (isDisableForDay) {
                          addAlert({
                            message:
                              'La fecha de venta no puede ser mayor a la fecha actual',
                            status: 'error',
                          })
                          return
                        }

                        if (isPaymentMethod) {
                          if (
                            credit?.finalDate &&
                            credit.installmentQuantity &&
                            credit.installmentRange &&
                            credit.installmentRange &&
                            credit.startDate
                          ) {
                            onCreateSell()
                            return
                          } else if (
                            !credit?.finalDate &&
                            !credit?.installmentQuantity &&
                            !credit?.installmentRange &&
                            !credit?.installmentRange &&
                            !credit?.startDate
                          ) {
                            onCreateSell()
                            return
                          } else {
                            addAlert({
                              message:
                                'Por favor, ingresar toda la información',
                              status: 'error',
                            })
                            return
                          }
                        }
                        // if (status === 'PENDING' && isPaymentMethod) {
                        //   if (isFreeForm) {
                        //     onCreateFreeFormFromPending()
                        //     return
                        //   }
                        //   onEditSale()
                        //   return
                        // }

                        // if (status === 'REFUND' && isPaymentMethod) {
                        //   if (isFreeForm) {
                        //     onCreateSellByFreeForm()
                        //     return
                        //   }
                        //   onCreateSell()
                        //   return
                        // }

                        // if (status === 'DELIVERY_NOTE' && isPaymentMethod) {
                        //   onCreateDeliveryNote()
                        // }

                        // if (
                        //   status === 'DELIVERY_NOTE_TO_SALE' &&
                        //   isPaymentMethod
                        // ) {
                        //   if (isFreeForm) {
                        //     onConvertToFreeFormSale()
                        //     return
                        //   }
                        //   onConvertToInvoiceSale()
                        //   return
                        // }

                        // /* Para cuando se pasa de pendiente a nota de entrega */
                        // if (status === 'PENDING_DELIVERY' && isPaymentMethod) {
                        //   // if (isFreeForm) {
                        //   //   onConvertPendingDeliveryNoteFreeForm()
                        //   //   return
                        //   // }
                        //   onConvertPendingDeliveryNote()
                        //   return
                        // }

                        // if (status === 'COUNTERFOIL' && isPaymentMethod) {
                        //   // console.log("counterfoil...")
                        //   setShowModalControlNumber(true)
                        // }

                        setIsPaymentMethod(true)
                      }}
                      disabled={selectedItems?.length === 0}
                      className="text-white border-none dark:text-white dark:hover:text-white dark:focus:text-white hover:text-white focus:text-white bg-gradient-to-bl from-primary to-primary-dark dark:hover:bg-primary focus:bg-primary dark:focus:bg-primary"
                    >
                      <p className="ml-1.5 font-medium tracking-wide flex flex-grow items-center justify-center">
                        Continuar
                      </p>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Right side */}
            <div className="h-full">
              <div className="bg-light-100 dark:bg-black rounded-xl h-full p-4 grid grid-rows-6">
                <div className="row-start-1 row-end-1">
                  <div className="flex justify-between">
                    <h1 className="text-sm text-primary-700 dark:text-white uppercase">
                      Nro. Control:{' '}
                      <strong className="text-primaryGray-400 font-normal">
                        {invoiceMemo}
                      </strong>
                    </h1>
                    <h1 className="text-sm text-primary-700 dark:text-white uppercase">
                      Nro. Documento:{' '}
                      <strong className="text-primaryGray-400 font-normal">
                        {tenantConfig?.invoiceCode}
                      </strong>
                    </h1>
                  </div>

                  <div className="flex justify-between">
                    <h1 className="text-sm text-primary-700 dark:text-white uppercase">
                      {selectedClient
                        ? `${selectedClient.name}`
                        : 'Nombre del cliente'}
                    </h1>
                    <h1 className="text-sm text-primary-700 dark:text-white uppercase">
                      Documento Legal
                    </h1>
                  </div>
                  <div className="flex justify-between">
                    <h1 className="text-sm text-primaryGray-400 dark:text-white font-normal uppercase">
                      {getCurrentDate()}
                    </h1>
                    <h1 className="text-sm text-primaryGray-400 dark:text-white font-normal uppercase">
                      {selectedClient
                        ? `${selectedClient.documentType}${selectedClient.document}`
                        : ''}
                    </h1>
                  </div>
                </div>

                <div className="row-start-2 row-end-6">
                  <div className="max-h-72 overflow-y-auto">
                    {selectedItems?.length === 0 && (
                      <div className="text-sm text-primary-700 dark:text-white text-center">
                        SIN PRODUCTOS
                      </div>
                    )}

                    {selectedItems &&
                      selectedItems?.length > 0 &&
                      selectedItems?.map((item, i) => {
                        return (
                          <div className="mb-3">
                            <div className="grid grid-cols-[100px_6fr_2fr_1fr] gap-4 items-center">
                              <div className="flex justify-center items-center">
                                <div
                                  className="flex flex-row justify-center items-center"
                                  style={{ width: 200 }}
                                >
                                  <IoMdAdd
                                    className="text-primary cursor-pointer mr-2"
                                    onClick={() => {
                                      let selected = [...selectedItems]
                                      selected[i].amount =
                                        +selected[i].amount + 1 + ''
                                      setSelectedItems(selected)
                                    }}
                                  />
                                  {/* <CurrencyInput
                                id="input-example"
                                decimalSeparator="," groupSeparator="."
                                decimalsLimit={2}
                                defaultValue={1}
                                // value={selectedItems[i].amount}
                                onValueChange={(value, _, values)  => {
                                  console.log("VALUE", value)
                                  console.log("VALUE", values)
                                  let selected = [...selectedItems]
                                  selected[i].amount =
                                    value === '0'
                                      ? '1'
                                      : values?.float + ""
                                  setSelectedItems(selected)
                                }}
                              /> */}
                                  <input
                                    type="number"
                                    ref={amountRef}
                                    value={String(+item.amount)}
                                    onChange={(e) => {
                                      let selected = [...selectedItems]
                                      selected[i].amount =
                                        e.target.value === '0'
                                          ? '1'
                                          : e.target.value
                                      setSelectedItems(selected)
                                    }}
                                  />
                                  <BiMinus
                                    className="text-primary cursor-pointer ml-2"
                                    onClick={() => {
                                      let selected = [...selectedItems]
                                      if (+selected[i].amount > 1) {
                                        selected[i].amount =
                                          +selected[i].amount - 1 + ''
                                      }
                                      setSelectedItems(selected)
                                    }}
                                  />
                                </div>
                              </div>

                              <div
                                className={`${
                                  (status === 'DELIVERY_NOTE' ||
                                    status === 'PENDING_DELIVERY') &&
                                  'flex items-center'
                                }`}
                              >
                                <h1 className="text-sm text-primary-700 dark:text-white">
                                  {item?.name}
                                </h1>
                                {status !== 'DELIVERY_NOTE' &&
                                  status !== 'PENDING_DELIVERY' && (
                                    <div className="flex flex-row">
                                      <h1 className="text-sm text-primaryGray-400 dark:text-white font-medium mr-3">
                                        {item?.ivaType === 'EXEMPT'
                                          ? 'Exento'
                                          : `${(
                                              getIvaNumber(item?.ivaType) + ''
                                            ).replace(/\d\./, '')}%`}
                                      </h1>
                                      <h1 className="text-sm text-primaryGray-400 dark:text-white font-medium">
                                        Código {item.sku}
                                      </h1>
                                    </div>
                                  )}
                              </div>

                              <div
                                className={`text-right ${
                                  (status === 'DELIVERY_NOTE' ||
                                    status === 'PENDING_DELIVERY') &&
                                  'flex items-center'
                                }`}
                              >
                                <h1 className="text-sm text-primary-700 dark:text-white w-full">
                                  {/* {item?.ivaType === 'EXEMPT'
                                  ? (
                                      +item?.price * +item.amount
                                    ).toFixed(2)
                                  : (
                                      +(
                                        +item?.price /
                                        getIvaNumber(item?.ivaType)
                                      ) * +item?.amount
                                    ).toFixed(2)  } */}
                                  {`Bs. ${formatPipeSaleItems(
                                    item.price,
                                    item.amount,
                                    item?.currency?.id
                                  )}`}
                                </h1>
                                {status !== 'DELIVERY_NOTE' &&
                                  status !== 'PENDING_DELIVERY' && (
                                    <h1 className="text-sm text-primaryGray-400 dark:text-white font-medium">
                                      {`Bs. ${
                                        item?.ivaType === 'EXEMPT'
                                          ? '0.00'
                                          : formatPipeSaleItemsIva(
                                              item.price,
                                              item.amount,
                                              item?.currency?.id,
                                              item?.ivaType as
                                                | 'GENERAL'
                                                | 'REDUCED'
                                                | 'EXEMPT'
                                                | 'SUMPTUARY'
                                            )
                                      }`}
                                    </h1>
                                  )}
                              </div>

                              <div className="col-span-1 flex items-center w-full">
                                {(status === 'PENDING' ||
                                  status === 'PENDING_DELIVERY' ||
                                  status === 'DELIVERY_NOTE_TO_SALE') &&
                                  item.enableEdit && (
                                    <HiCheck
                                      size={20}
                                      className="text-primary-700 cursor-pointer w-full"
                                      onClick={() => onSaveUpdateItem(item, i)}
                                    />
                                  )}

                                {(status === 'PENDING' ||
                                  status === 'PENDING_DELIVERY' ||
                                  status === 'DELIVERY_NOTE_TO_SALE') &&
                                  !item.enableEdit &&
                                  !alreadySelled && (
                                    <HiOutlinePencil
                                      size={20}
                                      className="text-primary-700 cursor-pointer w-full"
                                      onClick={() => onUpdateItem(i)}
                                    />
                                  )}
                                {!alreadySelled && !isPaymentMethod && (
                                  <RiDeleteBin6Line
                                    className="cursor-pointer w-full text-primary-700"
                                    onClick={() =>
                                      onDeleteItemsSelected(item, i)
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>

                          // <div className="mb-3">
                          //   <div className="flex justify-between">
                          //     <h1 className="text-sm">{item?.name}</h1>
                          //     <h1 className="text-sm">
                          //       {+item?.price[item?.price?.length - 1]?.amount *
                          //         +item?.amount}
                          //     </h1>
                          //   </div>
                          //   <div className="flex justify-between">
                          //     <h1 className="text-sm">
                          //       {item?.exempt ? 'Excento' : '16%'}
                          //     </h1>
                          //     <h1 className="text-sm">
                          //       {item?.exempt
                          //         ? '0.00'
                          //         : (
                          //             +item?.price[item?.price?.length - 1]
                          //               ?.amount *
                          //             0.16 *
                          //             +item?.amount
                          //           ).toFixed(2)}
                          //     </h1>
                          //   </div>
                          // </div>
                        )
                      })}
                  </div>
                </div>

                <div
                  className="row-start-6 row-end-6"
                  style={{ marginTop: '-70px' }}
                >
                  {/* {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                  <div className="flex justify-between">
                    <h1 className="text-sm">EXENTO</h1>
                    <h1 className="text-sm">
                      Bs. {sumOfValues('exempt').toFixed(2)}
                    </h1>
                  </div>
                )} */}

                  {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                    <div className="flex justify-between">
                      <h1 className="text-sm">SUB TOTAL</h1>
                      <h1 className="text-sm">
                        Bs.{' '}
                        {formatPipe(
                          toFixed(sumOfValues('sub_total'), 2).replace('.', ',')
                        )}
                      </h1>
                    </div>
                  )}

                  {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                    <div className="flex justify-between">
                      <h1 className="text-sm">EXENTO</h1>
                      <h1 className="text-sm">
                        Bs.{' '}
                        {formatPipe(
                          toFixed(sumOfValues('exempt'), 2).replace('.', ',')
                        )}
                      </h1>
                    </div>
                  )}

                  <div>
                    <div className="flex justify-between">
                      <div className="flex flex-row justify-center items-center">
                        <h1 className="text-sm mr-3">DESCUENTO</h1>
                        <Switch
                          forForm={true}
                          value={disableDiscount}
                          onChange={(value) => {
                            setDiscountValue(0)
                            setDisableDiscount(value)
                            discountRef.current.value = '0'
                          }}
                        />
                      </div>
                      <div className="w-16">
                        <input
                          // min={0}
                          type="text"
                          className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                          disabled={!disableDiscount}
                          ref={discountRef}
                          // onKeyUp={(e) => {
                          //   const value = (e.target as HTMLInputElement).value
                          //   console.log("VALUE", value)
                          //   console.log("TOTAL", toFixed(getTotalAmount(false), 2))
                          //   if (+value > +toFixed(getTotalAmount(false), 2)) {
                          //     addAlert({
                          //       message: 'El descuento no puede ser mayor al subtotal',
                          //       status: 'error'
                          //     });
                          //     (e.target as HTMLInputElement).value = '0';
                          //     discountRef.current.value = '0'
                          //     // setDiscountValue(0);
                          //   }
                          // }}
                          // value={discountValue}
                          // onChange={(e) => setDiscountValue(+e.target.value)}
                          // ref={discountInput}
                          // value={discountInput}
                          // onChange={(e) => setDiscountInput(e.target.value)}
                        />
                      </div>
                      {/* <InputNumber label='' disabled={!disableDiscount}  /> */}
                    </div>
                  </div>

                  {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                    <div className="flex justify-between">
                      <h1 className="text-sm">IVA</h1>
                      <h1 className="text-sm">
                        Bs.{' '}
                        {formatPipe(
                          toFixed(sumOfValues('iva'), 2).replace('.', ',')
                        )}
                      </h1>
                    </div>
                  )}

                  <div>
                    <div className="flex justify-between">
                      <div className="flex flex-row justify-center items-center">
                        <h1 className="text-sm mr-3">IGTF</h1>
                        {/* <Switch
                          value={isIGTFActive}
                          forForm={true}
                          onChange={(value) => {
                            console.log('VER SWITCH', value)
                            setIsIGTFActive(value)
                            if (value) {
                              if (!alreadySelled) {
                                setSelectedMethod({
                                  name: 'IGTF',
                                  icon: FaPercent,
                                  accountType: accountTypeEnum.IGTF,
                                })
                              }
                            } else {
                              setIgtfAmount(0)
                            }
                          }}
                        /> */}
                      </div>
                      <h1 className="text-sm">
                        Bs.{' '}
                        {formatPipe(toFixed(igtfAmount, 2).replace('.', ','))}
                      </h1>
                    </div>
                  </div>

                  <div
                    className={`flex justify-between ${
                      status === 'DELIVERY_NOTE' ||
                      status === 'PENDING_DELIVERY'
                        ? 'h-5/6 items-end'
                        : ''
                    }`}
                  >
                    <h1 className="text-sm">TOTAL</h1>
                    <h1 className="text-sm">
                      Bs.{' '}
                      {status === 'DELIVERY_NOTE' ||
                      status === 'PENDING_DELIVERY'
                        ? formatPipe(
                            toFixed(sumOfValues('sub_total'), 2)
                            // (
                            //   sumOfValues('sub_total') + sumOfValues('exempt')
                            // ).toFixed(2)
                          )
                        : +toFixed(getTotalAmount(false), 2) < discountValue
                        ? formatPipe(
                            toFixed(getTotalAmount(false), 2).replace('.', ',')
                          )
                        : formatPipe(
                            toFixed(getTotalAmount(true), 2).replace('.', ',')
                          )}
                    </h1>
                  </div>

                  {/* Mostrar desglose de retenciones si hay alguna */}
                  {selectedRetentions.length > 0 &&
                    status !== 'DELIVERY_NOTE' &&
                    status !== 'PENDING_DELIVERY' && (
                      <>
                        <div className="flex justify-between text-orange-600">
                          <h1 className="text-sm">- RETENCIONES</h1>
                          <h1 className="text-sm">
                            -Bs.{' '}
                            {formatPipe(
                              toFixed(getTotalRetentions(), 2).replace('.', ',')
                            )}
                          </h1>
                        </div>
                        <div className="flex justify-between border-t pt-2 mt-2">
                          <h1 className="text-sm font-semibold">TOTAL A PAGAR</h1>
                          <h1 className="text-sm font-semibold">
                            Bs.{' '}
                            {formatPipe(
                              toFixed(getTotalWithRetentions(), 2).replace('.', ',')
                            )}
                          </h1>
                        </div>
                      </>
                    )}

                  {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                    <div className="flex justify-between">
                      <h1 className="text-sm">TOTAL EN REF.</h1>
                      <h1 className="text-sm">
                        {+toFixed(getTotalAmount(false), 2) < discountValue
                          ? `${formatPipe(
                              toFixed(
                                getTotalAmount(false) / +onGetRate('1'),
                                2
                              ).replace('.', ',')
                            )}`
                          : `$${formatPipe(
                              toFixed(
                                getTotalAmount() / +onGetRate('1'),
                                2
                              ).replace('.', ',')
                            )}`}
                      </h1>
                    </div>
                  )}

                  {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                    <div className="flex justify-between">
                      <h1 className="text-sm">TOTAL EN REF (EUR)</h1>
                      <h1 className="text-sm">
                        {+toFixed(getTotalAmount(false), 2) < discountValue
                          ? `${formatPipe(
                              toFixed(
                                getTotalAmount(false) / +onGetRate('3'),
                                2
                              ).replace('.', ',')
                            )}`
                          : `€${formatPipe(
                              toFixed(
                                getTotalAmount() / +onGetRate('3'),
                                2
                              ).replace('.', ',')
                            )}`}
                      </h1>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {showPdf && (
          <>
            {digitalInvoicePdfUrl ? (
              // Mostrar PDF digital descargado
              <div style={{ width: '100%', height: '100vh' }}>
                <iframe
                  src={digitalInvoicePdfUrl}
                  title="Factura Digital"
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                />
              </div>
            ) : (
              // Mostrar PDF generado tradicionalmente
              <PdfSale
                invoiceNumber={invoiceNumber}
                paidOut={+debt === 0}
                client={{
                  name: selectedClient?.name,
                  address: selectedClient?.address,
                  phone: selectedClient?.phone1,
                  state: selectedClient?.state,
                  city: selectedClient?.city,
                  rif: `${selectedClient?.documentType}${selectedClient?.document}`,
                }}
                data={selectedItems?.map((v) => ({
                  amount: v.amount,
                  description: v.name,
                  individualPrice: +v.price * +onGetRate(v.currency.id),
                  totalPrice: +v.price * +v.amount * +onGetRate(v.currency.id),
                }))}
                date={saleDate}
                subTotal={toFixed(sumOfValues('sub_total'), 2)}
                descuento={toFixed(discountValue, 2)}
                igtf={toFixed(igtfAmount, 2)}
                //Iva general
                iva={saleData?.generalIVA || '0.00'}
                baseImponible={saleData?.generalTaxableBase || '0.00'}
                ivaSuntuario={saleData?.sumptuaryIVA || '0.00'}
                baseImponibleSuntuario={
                  saleData?.sumptuaryTaxableBase || '0.00'
                }
                //Iva reducido
                reducedIVA={saleData?.reducedIVA || '0.00'}
                reducedTaxableBase={saleData?.reducedTaxableBase || '0.00'}
                exempt={saleData?.exempt || '0.00'}
                total={toFixed(getTotalAmount(), 2)}
                // baseImponible={toFixed(+sumOfValues('sub_total') - +sumOfValues('exempt'), 2)}
              />
            )}
          </>
        )}

        {showPdfDeliveryNote && (
          <PdfView
            downloadTitle={`NotaDeEntrega-${'0'.repeat(
              6 - correlativeNumber.length
            )}${correlativeNumber}`}
            column_styles={{ Cant: { width: 200 } }}
            type="DELIVERY_NOTE"
            footer_render={{
              total: sumOfValues('sub_total') + sumOfValues('exempt'),
              clientName: `${selectedClient?.name} ${selectedClient?.surname}`,
              clientDocument: `${selectedClient?.documentType}-${selectedClient?.document}`,
            }}
            title={`Nota de entrega - ${'0'.repeat(
              6 - correlativeNumber.length
            )}${correlativeNumber}`}
            columns={[
              'Codigo',
              'Descripcion',
              'Cant',
              'Valor uni',
              'Valor Total',
            ]}
            data={formatRows()}
          />
        )}

        <Modal
          display={showModalItems}
          // modalClasses="w-3/5 py-4 px-12"
          onAccept={() => null}
          onClose={() => {
            setItemToSearch('')
          }}
        >
          <div>
            <Table
              columns={columnsSearchItems}
              data={itemsSearched}
              showPagination={false}
            />
          </div>
        </Modal>

        <Modal
          display={showAddClient}
          // modalClasses="w-3/6 py-4 px-12 overflow-scroll"
          onAccept={() => null}
          onClose={() => {
            setShowAddClient(false)
          }}
        >
          <ClientForm
            useType={'create'}
            onSubmit={onSubmit}
            onCancel={() => {
              setShowAddClient(false)
            }}
          />
        </Modal>

        {/* <ModalConfirm displayConfirmModal={isFreeForm} title={''} onCancel={() => {
        setIsFreeForm(false)
        checkedSaleCopy && checkedSaleCopy()
        }} onConfirm={() => null}  /> */}

        <Modal
          xlClasses="w-4/12"
          display={showModalControlNumber}
          onClose={() => setShowModalControlNumber(false)}
        >
          <ControlNumberForm
            onClose={() => setShowModalControlNumber(false)}
            onSubmitProp={onSubmitCounterFoil}
          />
        </Modal>

        <Modal
          display={showMethod}
          onClose={() => {
            setShowMethod(false)
            setIsIGTFActive(false)
          }}
          // modalClasses="w-1/3 py-4 px-12"
          normalClasses="overflow-visible"
        >
          <>
            {/* {selectedMethod?.accountType === accountTypeEnum.CREDIT && (
            <h1>Credit</h1>
          )} */}

            {selectedMethod?.accountType === accountTypeEnum.IGTF && (
              <IgtfForm
                onCancel={() => {
                  setShowMethod(false)
                  setIsIGTFActive(false)
                }}
                rate={globalRate}
                onSubmit={(v) => {
                  if (v === 0) {
                    setIsIGTFActive(false)
                  } else {
                    setIsIGTFActive(true)
                  }
                  console.log('V', v)
                  setIgtfAmount(v)
                }}
              />
            )}

            {selectedMethod?.accountType === accountTypeEnum.BANKACCOUNT && (
              <div>
                <TransferForm
                  rate={globalRate}
                  debt={debt}
                  onSubmitProp={(v) => onSelectMethod(v, v.type_account)}
                  onCancel={() => setShowMethod(false)}
                  options={[
                    { text: 'Pago movil', value: 'mobilePayment' },
                    {
                      text: 'Transferencia Nacional',
                      value: 'nationalTransfer',
                    },
                  ]}
                />
              </div>
            )}

            {selectedMethod?.accountType === accountTypeEnum.CASH && (
              <div>
                <CashForm
                  rate={globalRate}
                  debt={
                    status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? toFixed(
                          +toFixed(sumOfValues('sub_total'), 2) +
                            +toFixed(sumOfValues('exempt'), 2) -
                            +toFixed(
                              +selectedMethods.reduce(
                                (a, b) => a + +b.amount,
                                0
                              ),
                              2
                            ),
                          2
                        )
                      : debt
                  }
                  // total={
                  //   +(
                  //     getTotalAmount() -
                  //     +selectedMethods
                  //       .reduce((a, b) => a + +b.amount, 0)
                  //       .toFixed(2)
                  //   ).toFixed(2)
                  // }

                  onCancel={() => setShowMethod(false)}
                  onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.CASH)}
                />
              </div>
            )}

            {selectedMethod?.accountType === accountTypeEnum.CARD && (
              <div>
                <CardForm
                  debt={
                    status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? toFixed(
                          sumOfValues('sub_total') +
                            sumOfValues('exempt') -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                        )
                      : debt
                  }
                  total={
                    +toFixed(
                      getTotalAmount() -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                      2
                    )
                    // +(
                    //   getTotalAmount() -
                    //   +selectedMethods
                    //     .reduce((a, b) => a + +b.amount, 0)
                    //     .toFixed(2)
                    // ).toFixed(2)
                  }
                  onCancel={() => setShowMethod(false)}
                  onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.CARD)}
                />
              </div>
            )}

            {selectedMethod?.accountType === accountTypeEnum.WALLET && (
              <div>
                <WalletForm
                  rate={globalRate}
                  debt={
                    status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? toFixed(
                          sumOfValues('sub_total') +
                            sumOfValues('exempt') -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                      : // (
                        //     sumOfValues('sub_total') +
                        //     sumOfValues('exempt') -
                        //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                        //   ).toFixed(2)
                        toFixed(
                          getTotalAmount() -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                    // (
                    //     getTotalAmount() -
                    //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                    //   ).toFixed(2)
                  }
                  total={
                    +toFixed(
                      getTotalAmount() -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                      2
                    )
                    // +(
                    //   getTotalAmount() -
                    //   +selectedMethods
                    //     .reduce((a, b) => a + +b.amount, 0)
                    //     .toFixed(2)
                    // ).toFixed(2)
                  }
                  onCancel={() => setShowMethod(false)}
                  onSubmitProp={(v) =>
                    onSelectMethod(v, accountTypeEnum.WALLET)
                  }
                />
              </div>
            )}

            {selectedMethod?.accountType === accountTypeEnum.C2P && (
              <div>
                <C2pForm
                  rate={globalRate}
                  debt={
                    status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? toFixed(
                          sumOfValues('sub_total') +
                            sumOfValues('exempt') -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                      : // (
                        //     sumOfValues('sub_total') +
                        //     sumOfValues('exempt') -
                        //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                        //   ).toFixed(2)
                        toFixed(
                          getTotalAmount() -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                    // (
                    //     getTotalAmount() -
                    //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                    //   ).toFixed(2)
                    // +(
                    //   getTotalAmount() -
                    //   +selectedMethods
                    //     .reduce((a, b) => a + +b.amount, 0)
                    //     .toFixed(2)
                    // ).toFixed(2)
                  }
                  onCancel={() => setShowMethod(false)}
                  onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.C2P)}
                />
              </div>
            )}

            {selectedMethod?.accountType === accountTypeEnum.ZELLE && (
              <div>
                <ZelleForm
                  rate={globalRate}
                  onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.ZELLE)}
                  onCancel={() => setShowMethod(false)}
                  total={
                    +toFixed(
                      getTotalAmount() -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                      2
                    )
                    // +(
                    //   getTotalAmount() -
                    //   +selectedMethods
                    //     .reduce((a, b) => a + +b.amount, 0)
                    //     .toFixed(2)
                    // ).toFixed(2)
                  }
                  debt={
                    status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? toFixed(
                          sumOfValues('sub_total') +
                            sumOfValues('exempt') -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                      : // (
                        //     sumOfValues('sub_total') +
                        //     sumOfValues('exempt') -
                        //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                        //   ).toFixed(2)
                        toFixed(
                          getTotalAmount() -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                    // (
                    //     getTotalAmount() -
                    //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                    //   ).toFixed(2)
                    // +(
                    //   getTotalAmount() -
                    //   +selectedMethods
                    //     .reduce((a, b) => a + +b.amount, 0)
                    //     .toFixed(2)
                    // ).toFixed(2)
                  }
                />
              </div>
            )}

            {selectedMethod?.accountType === accountTypeEnum.PAGO_MOVIL && (
              <div>
                <PagoMovilForm
                  rate={globalRate}
                  onSubmitProp={(v) =>
                    onSelectMethod(v, accountTypeEnum.PAGO_MOVIL)
                  }
                  onCancel={() => setShowMethod(false)}
                  total={
                    +toFixed(
                      getTotalAmount() -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                      2
                    )
                    // +(
                    //   getTotalAmount() -
                    //   +selectedMethods
                    //     .reduce((a, b) => a + +b.amount, 0)
                    //     .toFixed(2)
                    // ).toFixed(2)
                  }
                  debt={
                    status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? toFixed(
                          sumOfValues('sub_total') +
                            sumOfValues('exempt') -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                      : // (
                        //     sumOfValues('sub_total') +
                        //     sumOfValues('exempt') -
                        //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                        //   ).toFixed(2)
                        toFixed(
                          getTotalAmount() -
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                          2
                        )
                    // (
                    //     getTotalAmount() -
                    //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                    //   ).toFixed(2)
                    // +(
                    //   getTotalAmount() -
                    //   +selectedMethods
                    //     .reduce((a, b) => a + +b.amount, 0)
                    //     .toFixed(2)
                    // ).toFixed(2)
                  }
                />
              </div>
            )}

            {selectedMethod?.accountType === accountTypeEnum.RETENTION && (
              <div>
                <RetentionForm
                  rate={globalRate}
                  debt={debt}
                  onSubmitProp={(v) =>
                    onSelectMethod(v, accountTypeEnum.RETENTION)
                  }
                  onCancel={() => setShowMethod(false)}
                  selectedClient={selectedClient}
                  totalIncluyendoIva={getTotalAmount()}
                  exento={sumOfValues('exempt')}
                  baseImponible={
                    new Decimal(sumOfValues('sub_total'))
                      .minus(new Decimal(sumOfValues('exempt')))
                      .toDecimalPlaces(2)
                      .toNumber()
                  }
                  iva={sumOfValues('iva')}
                />
              </div>
            )}

            {/* {selectedMethod?.accountType === accountTypeEnum.CREDIT && (
            <div>
              <CreditForm
                debt={
                  status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                    ? (
                        sumOfValues('sub_total') +
                        sumOfValues('exempt') -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                      ).toFixed(2)
                    : (
                        getTotalAmount() -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                      ).toFixed(2)
                }
                total={
                  +(
                    getTotalAmount() -
                    +selectedMethods
                      .reduce((a, b) => a + +b.amount, 0)
                      .toFixed(2)
                  ).toFixed(2)
                }
                credit={selectedClient && +selectedClient.credit}
                onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.CREDIT)}
                onCancel={() => {
                  setSelectedMethod(null)
                  setShowMethod(false)
                }}
              />
            </div>
          )} */}
          </>
        </Modal>

        <Modal
          display={showAdvancedPayable}
          onClose={() => setShowAdvancedPayable(false)}
        >
          <h2 className="text-base text-primary">
            {`Tu pago supera en Bs.${+debt * -1} el costo de la venta 
          ¿Cómo deseas registrar el excedente del pago?"`}
          </h2>
          <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div>

          <div className="flex flex-row justify-around mt-5">
            <label
              className="cursor-pointer hover:text-primary"
              style={{ flexBasis: '40%' }}
              onClick={async () => {
                let body = returnBody('PAYABLE')
                const today = DateTime.local().setLocale('es')

                try {
                  addAlert({
                    message: 'Creando venta...',
                    status: 'loading',
                  })
                  let response = await axios.post(`${server}/sale`, body)
                  if (selectedClient?.email && selectedClient?.emailConfirmed) {
                    let emailBody = {
                      invoiceCode: response?.data?.invoice?.code,
                      nevulaUser: {
                        businessName: userName,
                      },
                      client: {
                        name: selectedClient?.name,
                        document: `${selectedClient?.documentType}-${selectedClient?.document}`,
                        email: selectedClient?.email,
                      },
                      // subTotal: sumOfValues('sub_total').toFixed(2),
                      subTotal: toFixed(sumOfValues('sub_total'), 2),
                      // iva: sumOfValues('iva').toFixed(2),
                      iva: toFixed(sumOfValues('iva'), 2),
                      discount: discountValue + '',
                      // igtf: igtfAmount.toFixed(2),
                      igtf: toFixed(igtfAmount, 2),
                      // total: getTotalAmount().toFixed(2),
                      total: toFixed(getTotalAmount(), 2),
                      date: today.toFormat('dd/MM/yyyy'),
                      userMessage: 'Gracias por tu compra',
                      logoURL:
                        'https://i.pinimg.com/736x/ec/7c/af/ec7cafae1224c318796d41e728eacb6d.jpg',
                      items: selectedItems?.map((item) => ({
                        quantity: item.amount,
                        description: item.name,
                        unitPrice: item.price,
                        totalPrice: +item?.amount * +item?.price,
                      })),
                    }
                    console.log('EMAIL BODY', emailBody)
                    let responseEmail = await axios.post(
                      `${server}/sale/email`,
                      emailBody
                    )
                  }
                  setInvoiceNumber(response?.data?.invoice?.code)
                  addAlert({
                    message: 'Venta creada satisfactoriamente',
                    status: 'success',
                  })
                  setShowAdvancedPayable(false)
                  setShowPdf(true)
                } catch (err) {
                  addAlert({
                    message: 'Error al crear la venta',
                    status: 'error',
                  })
                }

                // onFinish()
              }}
            >
              Registrar como deuda por pagar al cliente
            </label>
            <label
              className="cursor-pointer hover:text-primary"
              style={{ flexBasis: '40%' }}
              onClick={async () => {
                let body = returnBody('ADVANCE')
                const today = DateTime.local().setLocale('es')

                try {
                  addAlert({
                    message: 'Creando venta...',
                    status: 'loading',
                  })
                  let response = await axios.post(`${server}/sale`, body)
                  if (selectedClient?.email && selectedClient?.emailConfirmed) {
                    let emailBody = {
                      invoiceCode: response?.data?.invoice?.code,
                      nevulaUser: {
                        businessName: userName,
                      },
                      client: {
                        name: selectedClient?.name,
                        document: `${selectedClient?.documentType}-${selectedClient?.document}`,
                        email: selectedClient?.email,
                      },
                      // subTotal: sumOfValues('sub_total').toFixed(2),
                      subTotal: toFixed(sumOfValues('sub_total'), 2),
                      // iva: sumOfValues('iva').toFixed(2),
                      iva: toFixed(sumOfValues('iva'), 2),
                      discount: discountValue + '',
                      // igtf: igtfAmount.toFixed(2),
                      igtf: toFixed(igtfAmount, 2),
                      // total: getTotalAmount().toFixed(2),
                      total: toFixed(getTotalAmount(), 2),
                      date: today.toISODate(),
                      userMessage: 'Gracias por tu compra',
                      logoURL:
                        'https://i.pinimg.com/736x/ec/7c/af/ec7cafae1224c318796d41e728eacb6d.jpg',
                      items: selectedItems?.map((item) => ({
                        quantity: item.amount,
                        description: item.name,
                        unitPrice: item.price,
                        totalPrice: +item?.amount * +item?.price,
                      })),
                    }
                    let responseEmail = await axios.post(
                      `${server}/sale/email`,
                      emailBody
                    )
                  }
                  setInvoiceNumber(response?.data?.invoice?.code)
                  addAlert({
                    message: 'Venta creada satisfactoriamente',
                    status: 'success',
                  })
                  setShowAdvancedPayable(false)
                  setShowPdf(true)
                } catch (err) {
                  addAlert({
                    message: 'Error al crear la venta',
                    status: 'error',
                  })
                }
                setShowAdvancedPayable(false)
                // onFinish()
              }}
            >
              Registrar como anticipo al cliente
            </label>
          </div>
        </Modal>

        <Modal
          xlClasses="xl:w-2/5"
          // display={!!modalRate} Se inhabilito por req. del Seniat
          display={false}
          onClose={() => setModalRate(null)}
        >
          <div>
            <div className="mb-2 flex items-center">
              <h1>Atención</h1>
            </div>
            <label>
              Se utilizará la tasa Bs/USD de la fecha seleccionada:{' '}
              <strong>
                Bs.{' '}
                {formatPipe(toFixed(+(modalRate || 0), 2).replace('.', ','))}
              </strong>
            </label>
            <div className="flex justify-center mt-5">
              <Button
                // style={returnStyle('ArrowRight')}
                classes="rounded w-5/12"
                type="primary"
                // style={{borderColor: '#D32F2F' }}
                onClick={() => setModalRate(null)}
              >
                Confirmar
              </Button>
            </div>
          </div>
        </Modal>

        <Modal
          xlClasses="xl:w-2/5"
          display={showIgtfModal}
          onClose={() => setShowIgtfModal(false)}
        >
          <div>
            <div className="mb-2 flex items-center">
              <h1 className="text-lg font-semibold">Atención</h1>
            </div>

            <p className="text-sm leading-relaxed">
              El monto ingresado en <strong>divisas</strong> cubre el total de
              la venta. <br />
              ¿Deseas <strong>incluir el IGTF</strong> en este mismo pago?{' '}
              <br />
              Si decides no hacerlo, deberás registrar un{' '}
              <strong>pago adicional en bolívares</strong> para cubrir el
              impuesto.
            </p>

            <div className="flex justify-center gap-4 mt-6">
              {/* Botón para incluir el IGTF en el pago en divisas */}
              <Button
                classes="rounded w-5/12"
                type="primary"
                onClick={() => {
                  handleIncludeIgtfInUsdPayment() // tu función para sumar el IGTF

                  setShowIgtfModal(false)
                }}
              >
                Incluir IGTF
              </Button>

              {/* Botón para registrar el IGTF como pago en Bs */}
              <Button
                classes="rounded w-5/12"
                type="primary"
                onClick={() => {
                  // handleRegisterBsPaymentForIgtf() // tu función para agregar el pago en Bs
                  setShowIgtfModal(false)
                }}
              >
                Pagar IGTF en Bs
              </Button>
            </div>
          </div>
        </Modal>

        <Modal
          xlClasses="w-[550px]"
          display={showInvoiceMethodModal}
          onClose={() => setShowInvoiceMethodModal(false)}
        >
          <div>
            <div className="mb-2 flex items-center">
              <h1>Atención</h1>
            </div>
            <div className="mt-[20px]">
              <label>
                No puede generar una venta en la versión web si su tipo de
                facturación no es Forma libre o Digital.
              </label>
            </div>
          </div>
        </Modal>

        <Modal
          xlClasses="xl:w-2/5 overflow-visible"
          display={showCloseBoxModal}
          onClose={() => setShowCloseBoxModal(false)}
        >
          <div>
            <label>
              Si tienes una cuenta asociada a la caja registradora (a modo de
              caja chica por ejemplo), selecciónala abajo. De lo contrario,
              obvia este paso:
            </label>
            <div className="flex flex-col items-center mt-5">
              <div
                className="flex flex-row justify-center mb-5"
                style={{ width: '90%' }}
              >
                <Select
                  options={accountsSelect}
                  onChange={(v) => {
                    setSelectedAccount(v)
                  }}
                />
              </div>

              <div
                className="flex flex-row justify-between"
                style={{ width: '90%' }}
              >
                <Button
                  // style={returnStyle('ArrowRight')}
                  classes="rounded w-5/12"
                  type="outline"
                  // style={{borderColor: '#D32F2F' }}
                  onClick={() => setShowCloseBoxModal(false)}
                >
                  Cancelar
                </Button>
                <Button
                  // style={returnStyle('ArrowRight')}
                  classes="rounded w-5/12"
                  type="primary"
                  // style={{borderColor: '#D32F2F' }}
                  onClick={() => onGetCloseBox()}
                >
                  Aceptar
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  )
}

interface IExistencesResponse {
  date: string
  item: IItem
  location: IWarehouse
  quantity: string
}

interface IMethods {
  name: string
  icon: IconType | null
  accountType: accountTypeEnum
}

interface SellProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
  clientProp?: IClient | null
  itemsProp?: any[]
  statusProp?:
    | 'PENDING'
    | 'REFUND'
    | 'DELIVERY_NOTE'
    | 'DELIVERY_NOTE_TO_SALE'
    | 'PENDING_DELIVERY'
    | 'FOOD_ORDER'
    | undefined
  selldId?: string
  payment_methods?: any[] | undefined
  onGoBack?: Function
  type?: string
  alreadySelledProp?: boolean
  dispatchStatusProps?: string
  paidOut?: boolean
  onContinue?: Function
  discountProp?: number | null
}

interface options {
  value: string
  text: string
}

interface Bill {
  quantity: number
  amountCash: number
}

export interface IGlobalRate {
  id: string
  rate: string
}

interface ICredit {
  installmentRange: string
  installmentQuantity: string
  startDate: string
  finalDate: string
}

export default Sells
